/* eslint-disable quotes */
export default {
  /* "key":"value" */

  /*App.js */
  'Notice.optimizedForChrome':
    '본 홈페이지는 크롬(Chrome)에 최적화 되어있습니다. 크롬(Chrome) 사용을 권장합니다.',

  /* PopUp */
  'PopUp.closeWindow.text': '하루 동안 이 창을 열지 않음',
  'ClosePopupCheckbox.text': '다시 보지 않기',
  'ClosePopup.button.text': '닫기',

  /* Antd - Popconfirm */
  'Popconfirm.cancelText': '취소',
  'Popconfirm.okText.delete': '삭제',
  'Popconfirm.okText.ok': '확인',

  /* Home.js */
  'Home.mainBanner.explain':
    '스티커 단 하나만 올려도 판매 시작<br/>mojitok과 함께 글로벌 크리에이터에 도전!',
  'Home.introduction.mojitokXstickerfarm':
    '삼성 Galaxy 시리즈, 애플 iMessage, Zalo 등<br/>1억명이 넘는 글로벌 유저가 사용하는 스티커 플랫폼입니다.',
  'Home.joinUs.title.01': '01  간단한 절차',
  'Home.joinUs.subtitle.01': '까다롭고 긴 심사에 <br/>지친 크리에이터라면',
  'Home.joinUs.description.01':
    '객관적인 기준을 바탕으로 심사 진행.<br/>딱 1개의 스티커만 등록해도 수익 발생.',
  'Home.joinUs.title.02': '02  글로벌 진출',
  'Home.joinUs.subtitle.02':
    '한국은 물론, 글로벌 시장까지<br/>노리는 크리에이터라면',
  'Home.joinUs.description.02':
    '한국 메신저는 당신에게 좁은 무대.<br/>전 세계 1억 명에게 스티커 판매 가능.',
  'Home.joinUs.title.03': '03  사용자 데이터 제공',
  'Home.joinUs.subtitle.03':
    '사람들이 요즘 쓰고 싶어하는 스티커를 <br/>알고싶은 크리에이터라면',
  'Home.joinUs.description.03':
    'mojitok 사용자들의 실시간 관심사 제공.<br/>스티커 개별 사용량 확인을 통해 <br/>사용자들의 선호도 확인 가능.',

  'Home.howToUse.title': 'How to use',
  'Home.howToUse.01': '크리에이터 등록',
  'Home.howToUse.01.explain':
    '필요한 정보를 등록한 후,<br/>크리에이터로 등록합니다.',
  'Home.howToUse.02': '스티커 제출',
  'Home.howToUse.02.explain':
    '스티커와 어울리는 감정태그를<br/>선택하고 업로드하세요.',
  'Home.howToUse.03': '심사',
  'Home.howToUse.03.explain':
    '합리적이고 공정한 기준을<br/>바탕으로 신속하게 진행됩니다.',
  'Home.howToUse.04': '출시 및 판매',
  'Home.howToUse.04.explain': '심사가 완료되면<br/>자동으로 판매가 시작됩니다!',
  'Home.button.signup': '스티커팜 가입하기',
  'Home.button.guideline': '스티커팜 가이드라인',
  'Home.featured.title': 'Featured Stickers',
  'Home.featured.popular': '지금 이만큼<br/> 적립되었어요',
  'Home.featured.popular.extraPoints': '보너스 적립금이<br/> 추가됩니다',
  'Home.mojitok.explain':
    '<span style="display:flex;justify-content:flex-end">꿀잼 스티커로 친구들과 채팅해보세요!</span><span style="display:flex;justify-content:flex-end">내 감정을 담아 표현해주는 똑똑한 메시지</span>',

  /* Login.js */
  'Login.input.email': '이메일',
  'Login.email.error.required': '이메일을 입력해주세요.',
  'Login.email.error.Type': '올바르지 않은 이메일 주소 입니다.',

  'Login.input.password': '비밀번호',
  'Login.password.error.required': '비밀번호를 입력해주세요.',

  'Login.error.invalid': '이메일 또는 비밀번호가 올바르지 않습니다',

  'Login.forgotPassword': '* 비밀번호를 잊으셨나요?',
  'Login.signUp': '* 회원이 아니신가요? <u>회원 가입하기</u>',

  /* Signup.js */
  'Signup.headline': '회원 가입',

  'Signup.input.email': '이메일',
  'Signup.email.error.required': '이메일을 입력해주세요.',
  'Signup.email.error.Type': '올바르지 않은 이메일 주소 입니다.',

  'Signup.input.nickname': '이름 또는 닉네임',
  'Signup.nickname.error.required': '이름 또는 닉네임을 입력해주세요.',
  'Signup.nickname.error.minLength': '닉네임은 3자 이상이어야 합니다.',
  'Signup.nickname.error.maxLength': '닉네임은 최대 20자까지 입력 가능합니다.',
  'Signup.nickname.error.foramt': '닉네임은 영어, 숫자만 입력할 수 있습니다.',
  'Signup.nickname.error.overlap': '닉네임이 중복입니다.',

  'Signup.input.password': '비밀번호',
  'Signup.password.error.required': '비밀번호를 입력해주세요.',
  'Signup.password.error.pattern':
    '비밀번호는 영문, 숫자, 특수기호를 포함하여 8자 이상이여야 합니다.',

  'Signup.input.confirm': '비밀번호 확인',
  'Signup.confirm.error.required': '비밀번호 확인을 해주세요.',
  'Signup.confirm.error.check.password':
    '입력한 두개의 비밀번호가 일치하지 않습니다.',

  'Signup.terms.checkbox': '동의합니다',
  //signup checkbox modal
  'Signup.agreementModal.title.terms': '이용 약관',
  'Signup.agreementModal.description.terms':
    '이 약관(이하 본 약관)은 주식회사 플랫팜(이하 “사업자”)가 운영하는 콘텐츠 플랫폼 <u>https://stickerfarm.mojitok.com</u> (이하 “스티커팜”라 한다)이용과 관련하여 스티커팜을 이용하는 크리에이터(이하 제작자)와 사업자간 규정하는 사항입니다.<br/><br/><br/><b>1. 정의</b><br/><br/>1.1. “콘텐츠”는 제작자가 사업자에게 제공하고, 사업자가 이용자들에게 제공할 수 있는 즉, 사업자가 구축하여 운영하는 스티커팜에서 저장되어 제공되고 있는 디지털 콘텐츠를 말한다.<br/><br/>1.2. “팩”는 개별 스티커를 개수 제한 없이 저장하고 관리 할 수 있는 폴더 개념 단위를 의미합니다.<br/><br/><b>2. 목적</b><br/><br/>본 계약은, 사업자가 운영하는 스티커팜을 통해 제작자의 콘텐츠를 이용자들에게 제공함에 있어 각자의 역량을 바탕으로 상호 협력하겠다는 의사와 의향을 분명히 하고 업무상의 공동이익 증진을 목적으로 합니다.<br/><br/><br/><b>3. 이용 약관에 대한 동의</b><br/><br/>3.1. 모든 제작자는 이용 약관에 명시된 조건에 따라 서비스를 이용해야 합니다. 제작자는 이용 약관에 동의하지 않는 한 서비스를 사용할 수 없습니다. 그러한 합의는 유효하고 취소할 수 없습니다.<br/><br/>3.2. 미성년자는 부모님이나 법적 보호자의 동의 하에만 본 서비스를 사용할 수 있습니다. 또한, 제작자는 비즈니스 용도로 서비스를 사용하는 경우 해당 비즈니스 기업은 기업용 이용 약관에 동의한 것으로 간주합니다<br/><br/>3.3. 실제로 본 서비스를 사용함으로써 제작자는 이용 약관에 동의 한 것으로 간주됩니다.<br/><br/>3.4. 서비스에 대해 별도의 이용 약관이 있는 경우, 대상자는 또한 별도의 이용 약관 및 이용 약관을 준수해야 합니다.<br/><br/><b>4. 콘텐츠 제공 등</b><br/><br/>제작자는 스티커팜에서 요구하는 형태로 사업자에게 콘텐츠를 제공하여야 하며, 본 서비스와 동일 또는 유사한 서비스에 등록되어 판매되고 있는 동일한 콘텐츠는 서비스가 제한됩니다.<br><br><b>5. 정산</b><br><br>사업자가 운영하는 서비스에서의 사용량과 타사 플랫폼에서의 수익을 분배합니다.<br>사업자가 타사 플랫폼에 콘텐츠를 제공한 경우, 타사 플랫폼으로부터 정산 받은 전체 수익의 30%(수수료 제외)를 창작자에게 지급합니다.<br><br>이때 개별 제작자에게 분배될 구체적인 정산금은 해당 제작자의 콘텐츠의 기여도에 따라 결정됩니다(기여도가 없는 경우 분배될 정산금이 없을 수 있습니다).<br>기여도 측정은 총 사용지수, 판매지수, 활동지수를 복합적으로 계산하여 결정되며 마이페이지에서 확인할 수 있습니다.<br><br>마이페이지의 수익은 100$ 이상 언제든지 계좌로 입금 신청 가능하며, 계좌 입금 신청 후 최대 45일 이내 신청한 계좌로 송금됩니다<br/><br/><b>6. 계정</b><br/><br/>6.1. 제작자는 본 서비스를 이용할 때 이름(별명), 전자 메일 주소, 지급을 처리하는 데 필요한 정보 (이름, 주소, 계좌번호, 주민등록번호)를 제공해야 합니다.<br> 그리고 제공한 정보는 진실하고, 정확하며, 최신으로 유지되어야 합니다.<br><br>6.2 본 서비스는 귀하의 정보를 보관하지 않으며, 수익금 지불을 위해 수집 된 정보(이름, 주소, 계좌번호, 주민번호)는 지급 즉시 폐기됩니다.<br><br>6.3. 본 서비스는 귀하의 계정 등록을 거부하거나, 귀하의 계정을 일시 중지 또는 삭제하거나, 사전 통지하지 않고 제작자와 본 서비스 사이에 체결된 계약을 해지할 수 있습니다.<br><br>6.4. 본 서비스에 대한 각 계정은 본인에게만 속합니다.<br>본 약관에 명시되어 있지 않는 한, 제작자는 자신의 계정을 제 3 자에게 양도하거나 대여할 수 없습니다.<br><br>6.5. "제작자"는 "스티커팜"에 언제든지 탈퇴를 요청할 수 있으며 "스티커팜"은 30일 이내 회원의 개인정보와 콘텐츠를 삭제처리합니다. 삭제된 콘텐츠는 복구가 불가능합니다.<br><br>6.6. "제작자"가 탈퇴 및 콘텐츠 배포 중단 요청을 하더라도 "스티커팜"을 통해서 공급되는 서비스를 통해 사용자가 구매한 콘텐츠는 사용자의 서비스 해지 혹은 탈퇴 전까지 제공 될 수 있습니다.<br><br><b>7. 책임</b><br><br>7.1. 본 서비스는 관계법령의 변경, 천재지변 또는 이에 준하는 불가항력으로 인하여 수익금, 콘텐츠 및 기타 본 서비스를 본 계약 내용에 준해 제공할 수 없는 경우에는 이에 대한 책임이 면제됩니다.<br><br>7.2. 본 서비스는 이용 약관에 따라 취한 모든 조치를 포함하여 서비스 이용과 관련하여 제작자가 입은 어떠한 손해에 대해서도 책임을 지지 않습니다.<br><br>7.3. 본 서비스는 사업자의 과실 (중대한 과실 제외)과 관련하여 간접적, 특별, 부수적, 결과적 또는 징벌적 손해 (불법 행위 또는 기타의 본 서비스 또는 제작자가 예견했거나 예측할 수 있는 손해를 포함하되 이에 국한되지 않음)에 대해 책임을 지지 않습니다.<br><br><b>8. 사업자의 권한</b><br><br>8.1. 사용권 : 사업자에 제공된 콘텐츠 전부에 대해 사업자는 판매 및 전송에 관한 권리와 사업자의 플랫폼 또는 콘텐츠 자체 홍보를 위한 활용에 대한 권리를 갖습니다.<br><br>8.2. 판매 : 판매란 개별 콘텐츠의 판매, 집합적 콘텐츠의 판매, 구독권의 판매 등 전부를 포함합니다.<br><br>8.3. 전송 : 전송이란 사업자의 플랫폼을 통한 채널 또는 실구매자에게 지속적인 전달 과정과 콘텐츠를 채널 또는 제작자가 플랫폼에서 자체 운영 가능할 수 있도록 콘텐츠 일부 또는 전부를 일회적으로 전달하는 과정을 포함합니다. 사업자가 판매﹒전송한 콘텐츠는 그 특성 및 개별 이용자의 이용 수단(각종의 어플리케이션 등)이나 이용방법 등에 따라 콘텐츠가 다운로드 또는 복제, 2차 가공될 가능성이 있습니다. 사업자는 위와 같은 이용자의 개별적이고 구체적인 콘텐츠 다운로드 또는 복제, 2차 가공 행위로 인하여 발생할 수 있는 법률 문제와 관련하여 사업자의 고의 또는 중대한 과실이 있는 경우를 제외하고는 제작자에 대하여 책임을 지지 아니하며, 이 경우 제작자는 이용자에 대하여 직접 책임을 물을 수 있습니다. 다만, 개별 이용자는 사업자가 제공하는 서비스 내의 창작툴 기능을 이용하여 구매한 콘텐츠에 텍스트나 그래픽 효과 등을 추가하여 커스터마이징하는 방법으로 2차 가공할 수 있고, 이와 같이 커스터마이징한 콘텐츠의 경우 이용자가 이를 판매할 수는 없지만 개인 모바일에서 메시지로 전송하는 방법으로 이용할 수는 있습니다.<br><br>8.4 홍보: 홍보란 사업자의 홈페이지 또는 관련 사이트에 노출, 사업자가 운영하는 소셜네트워크에 노출, 사업자의 파트너 채널에 노출, 언론 활동으로 인한 온라인 오프라인 매체상의 노출, 제안서 및 홍보 온라인 오프라인 자료에 노출 등 사업자가 직접적인 금전적 대가를 취하지 않는 마케팅의 모든 활동을 포함합니다.<br><br><b>9. 저작권 및 보증</b><br><br>9.1. 법적 능력 : 제작자는 14세 이상이고 본 계약 이후, 이에 동의 할 법적 능력이 있음을 보증합니다.<br><br>9.2. 납세 의무 : 본 서비스는 제작자에게 지급 된 수수료와 관련된 세금 문에 대해 책임을지지 않습니다. 거주 국가에서 요구되는 소득 및 모든 세금 신고는 제작자가 책임 져야 함을 보증합니다.<br><br>9.3. 지적 재산권 침해 금지 : 제작자는 제출하는 콘텐츠가 본 서비스에 의거하여 라이센스를 부여 받았다는 것을 보증하지 않습니다. 콘텐츠에 상표, 서비스 마크 및 로고를 포함하지 않고, 모든 지적 재산권을 포함하여 제 3 자의 권리를 침해하지 마십시오.<br><br>9.4. 부도덕 한 내용 없음 : 제작자의 콘텐츠에는 아동 학대 또는 착취, 음란물 침해, 포르노, 공격적, 정치적 승인, 인종 차별적, 인종적 또는 문화적 공격적이거나 외설적이거나 음란 한 내용, 성적으로 노골적인 내용, 부도덕 한 내용, 명예 훼손, 사생활 침해 또는 불법 또는 폭력이나 테러 행위를 지지하는 인종, 성별, 종교, 신앙 또는 성적 취향에 대해 차별적 인 경우.<br><br>9.5. 부여 권리 : 제작자의 콘텐츠와 관련하여 본 계약의 모든 권리를 본 서비스에 부여함에 있어 무조건적이고 취소 할 수 없는 모든 권한, 권리, 소유권 및 소유권을 가지고 있음을 진술하고 보증합니다.<br><br>9.6. 창조 비용 : 제작자가 업로드한 콘텐츠의 제작비용을 청구할 수 없습니다. 제작자는 해당 콘텐츠 작업에 참여하는 사람에게 모든 제작 비용을 지불했으며, 어떠한 이유에서든 제작 비용이 미결 상태로 남아 있거나 발생할 경우에는 그 책임은 제작자에게 있습니다.<br><br>9.7. 바이러스 / 악성 코드 : 본 서비스 서버 및 네트워크 시스템에 지장을 주는 행위, BOT, 치팅 툴 및 기타 기술적 수단을 이용해 서비스를 부정 조작하는 행위, 본 서비스의 오류를 의도적으로 이용하는 행위, 사업자에 대해 부당한 문의 또는 요구를 하는 행위 및 기타 사업자의 본 서비스 운영 또는 다른 제작자의 본 서비스 이용을 방해하거나 지장을 주는 행위 <br><br>9.8. 진정한 정보 : 제작자가 제공 한 모든 등록 정보, 문서 및 신분이 진실되고 정확하며 최신이며 오해의 소지가 없음을 보증하며 변경 사항이 발생할 때 본 서비스에 그러한 정보를 업데이트 해야합니다. <br><br>9.9. 지적 재산권 권리 : 제작자는 제작자의 콘텐츠가 어떠한 방식으로든 전세계 어디에서나 지적 재산권을 침해하지 않는다고 보증합니다. 제작자는 지적 재산권을 침해하는 내용을 업로드 할 수 없으며 그러한 침해 (또는 침해 가능성)를 본 서비스에 통보하고 지적 재산권 침해를 방지하기위한 모든 조치를 취할 의무가 있음에 동의합니다. 본 서비스는 제작자에게 통지하거나 참조하지 않고 지적 재산권을 침해하는 (또는 침해 할 수 있다고 생각하는) 내용을 사이트 및 배포 네트워크에서 삭제할 권리를 보유 합니다. <br><br><b>10. 제한 사항</b><br><br>본 서비스 이용 시 콘텐츠는 다음 사항에 의해 제한될 수 있습니다.<br><br>10.1. 도덕과 윤리<br><br>1) 범죄, 폭력, 성적 표현 등 미풍양속에 반하는 콘텐츠<br>2) 흡연 연상 및 흡연을 조장하는 콘텐츠<br>3) 반사회적인 내용이 포함 된 콘텐츠 <br>4) 사회적인 물의를 일으킬 소지가 있는 콘텐츠 <br>5) 욕설 및 폭언 등이 담긴 콘텐츠 <br>6) 특정 국적이나, 종교, 문화, 집단에 대한 공격으로 해석되거나 불쾌감을 유발할 소지가 있는 콘텐츠 <br><br>10.2. 비즈니스 및 광고 홍보와 같은 제안 <br><br>1) 제3자에게 이익을 제공하거나 서비스 및 광고/홍보를 위해 제작된 콘텐츠<br> 2) 기업에서 브랜드 및 서비스의 광고/홍보를 위해 제작된 콘텐츠<br>3) 개인과 기업의 협업에 의한 콘텐츠 <br>4) 광고성 문구를 포함하고 있는 콘텐츠<br><br>10.3 저작권 침해, 초상권 침해 및 표절 혐의<br><br>1) 다른 사람의 제품 또는 표절 된 저작권 또는 초상권을 침해 할 수 있는 콘텐츠<br><br><b>11. 준거법 및 분쟁 해결</b><br><br>본 약관은 한국어를 정본으로 하며, 대한민국의 법에 따라 규율되고 그에 따라 해석됩니다. 이 계약의 유효성, 무효성, 위반 또는 종료와 관련하여 제작자와 사업자 간에 발생하는 모든 분쟁, 논쟁 또는 청구는 서울 중앙 지방 법원에 제소합니다. (특별한 협의를 조건으로 함)<br><br><b>12. 수정</b><br><br>12.1. 사업자는 필요한 경우 본 약관 또는 별도의 이용약관을 변경할 수 있습니다.<br><br>12.2. 사업자가 약관을 변경할 경우에는 본 서비스의 웹사이트 내의 적절한 위치에 그 적용일자 7일 이전부터 적용일자까지 공지하며, 변경된 약관은 적용일자로부터 효력이 발생합니다. 다만, 제작자에게 불리하게 약관 내용을 변경하는 경우에는 최소한 30일 이상의 사전 유예기간을 두고 제작자가 사업자에게 미리 고지한 전자우편 이메일 주소로 개별 통지합니다.<br><br>12.3. 제작자가 이용약관 또는 별도의 이용약관 변경에 대한 공지기간 내에 다른 의사표시를 하지 아니한 채 적용일자 이후 본 서비스를 계속 이용함은 변경된 이용 약관 또는 별도의 이용약관에 대해 취소할 수 없는 것으로 봅니다. <br><br>12.4. 제작자는 서비스를 이용할 때 이용 약관의 최신버전을 정기적으로 참조하는 것이 좋습니다. <br><br><b>13. 통지</b><br><br>13.1. 사업자가 제작자에 대한 통지를 하는 경우 제작자가 사업자에게 미리 고지하여 지정한 전자우편 주소로 할 수 있습니다.<br><br>13.2. 사업자는 불특정다수 제작자에 대한 통지의 경우 2주일전에 뉴스레터를 통해 내 고지함으로써 개별 통지에 갈음할 수 있습니다. 다만 제작자 본인에게 중대한 영향을 미치는 사항에 대하여는 개별 통지합니다. <br><br>개정일 : 2020년 12월 4일<br>',
  'Signup.agreementModal.title.privacy': '개인 정보 보호 정책',
  'Signup.agreementModal.description.privacy':
    '<b>개인 정보 정책</b><br/><br/>주식회사 플랫팜. (이하 "회사")는 사용자의 동의에 따라 개인 정보를 수집, 사용 및 제공하며, \'우리는 적극적으로 사용자의 권리를 보장합니다.  회사는 정보 통신 서비스 제공 업체가 준수해야하는 대한민국의 관련 법률, 규정 및 지침을 준수합니다. "개인 정보 처리 정책"은 귀중한 개인 정보를 보호하여 사용자가 안전하게 서비스를 이용할 수 있도록 회사가 준수해야하는 지침을 의미합니다. 이 개인 정보 보호 정책은 Stickerfarm에 적용됩니다.<br/><br/><br/><b>개인 정보 수집</b><br/><br/>우리는 서비스 제공에 필요한 최소한의 개인 정보를 수집합니다.<br/><br/>[스티커팜 계정등록]<br/>이메일, 이름 (닉네임)<br/><br/>선택 (한국에만 해당)<br/>은행 계좌 정보, 주소, 주민등록번호<br/><br/><br/>[고객센터]<br/>이메일, 이름 (닉네임)<br/><br/><br/><br/><b>개인 정보를 수집하는 방법은 다음과 같습니다.</b><br/><br/>개인 정보를 수집 할 때 사전에 이용자에게 통보하고 동의를 구해야하며 다음과 같은 방법으로 개인 정보를 수집 합니다.<br/><br/>●	회원가입 및 서비스 이용 과정에서 사용자가 개인 정보 수집에 동의하고 직접 정보를 입력하는 경우.<br/>●	결제시 지불에 필요한 개인 정보.<br/>●	고객센터를 통한 상담 과정에서 메일, 전화 등<br/><br/><br/><b>개인 정보의 사용</b><br/><br/>회원 관리, 서비스 제공 및 개선, 새로운 서비스 개발에 사용됩니다.<br/>회원 가입 또는 서비스 이용시 당사는 홈페이지 또는 개별 응용 프로그램 또는 프로그램을 통해 아래와 같은 서비스를 제공하기 위해 필요한 최소한의 개인 정보를 수집합니다.<br/><br/>●	새로운 서비스를 개발하고, 다양한 서비스를 제공하며, 문의 또는 불만을 처리하고, 공지 사항을 전달합니다.<br/>●	유료 서비스를 이용할 때, 내용의 이전, 지불 결제.<br/>●	서비스의 원활한 운영 (계정 도용 및 불법 사용 포함)을 방해하는 행위를 방지하고 제재합니다.<br/>●	이벤트 / 이벤트 참여, 마케팅 및 광고에 사용합니다.<br/>●	음성 명령 인식 및 개인화 서비스.<br/>●	서비스 이용 내역, 접속 빈도 및 서비스 이용률, 개인 정보 보호 측면에서의 서비스 환경 구축, 맞춤형 서비스 제공, 서비스 개선 활용 등을 통계합니다.<br/><br/><br/><br/><b>개인 정보 제공</b><br/><br/>본 서비스는 고객의 동의 또는 법률이 제공하지 않는 한 고객의 개인 정보를 제 3 자에게 제공하지 않습니다.<br/><br/><br/><br/><b>개인 정보 파기</b><br/><br/>수집 및 사용 목적이 달성되면 개인 정보는 지체없이 폐기됩니다.<br/>전자적 파일 형태인 경우 복구 및 재생되지 않도록 안전하게 삭제합니다.<br/>한국의 경우, 지급과 관련된 정보는 해당 지급이 완료되는대로 즉시 폐기됩니다.<br/><br/><br/><br/><b>개인정보보호에 관련한 문의</b><br/><br/>서비스 이용과 관련한 문의, 불만, 자문 또는 기타 문의 사항은 개인 정보 보호 책임자 및 해당 부서에 문의하십시오. 본 서비스는 고객의 목소리에 귀 기울이고 고객에게 빠르고 충분한 응답을 주기 위해 최선을 다할 것입니다.<br/><br/><br/><br/>●	개인정보 보호책임자 : 이효섭<br/>●	전화 : 070-7560-7002<br/>●	문의처 : mojitok@platfarm.net<br/><br/><br/><strong>개인 정보 취급 방침이 변경되면</strong> 법률이나 서비스 변경을 반영하기 위해 개인 정보 보호 정책을 수정할 수 있습니다. 개인 정보 보호 정책이 변경되면  변경 사항을 게시하고 수정 된 개인 정보 보호 정책은 게시일에 적용됩니다.<br/>다만, 수집하는 개인 정보 항목의 변경이나 사용 목적 변경과 같은 고객의 권리가 크게 변경되기 최소한 30 일 전에 알려드립니다.<br/><br/><br/><br/>개정일: 2019년 10월 22일',

  'Signup.btn': '가입하기',

  //signup notification
  'Signup.noti.terms.check': '약관을 읽고, 동의해주세요. 📝',

  //signup success Modal
  'Signup.modal.btn': '확인',
  'Signup.modal.title': '지금 가입 메일을 전송했습니다',
  'Signup.modal.explain.underline': '혹시 메일을 받지 못하셨나요?',
  'Signup.modal.explain': '스팸함이나 입력하신 메일 주소를 다시 확인해주세요.',

  /* Reset.js */
  'Reset.headline': '비밀번호 재설정',

  'Reset.input.email': '이메일',
  'Reset.email.error.required': '이메일을 입력해주세요.',
  'Reset.email.error.Type': '올바르지 않은 이메일 주소 입니다.',

  'Reset.btn': '전송',

  //Reset success Modal
  'Reset.modal.btn': '확인',
  'Reset.modal.title': '지금 메일을 전송했습니다',
  'Reset.modal.explain.underline': '혹시 메일을 받지 못하셨나요?',
  'Reset.modal.explain': '스팸함이나 입력하신 메일 주소를 다시 확인해주세요.',

  /** pakcage status values */
  'PkgStatus.creating': '작성중',
  'PkgStatus.underReview': '심사중',
  'PkgStatus.approved': '승인 완료',
  'PkgStatus.approved.mypackage': '배포중',
  'PkgStatus.unapproved': '미승인',
  'PkgStatus.editing': '수정중',
  'PkgStatus.discontinue': '배포 중단',

  /* Upload.js */
  'Progress.numberOfSticker': '총 {count} 스티커 업로드가 완료되었습니다.',
  'Upload.packages.serverError':
    '무언가 잘못되었습니다. 나중에 다시 시도해주세요',

  /* Upload - navigation */
  'Upload.packages.nav.packageCreation': '팩 작성하기',
  'Upload.packages.nav.packagesInProgress': '작성중',
  'Upload.packages.nav.packagesOfReviewed': '심사 현황',
  'Upload.packages.goto.mypage': '작성중 페이지로 가기',
  'Upload.packages.goto.reviewedpage': '심사현황 페이지로 가기',

  /* Upload - pack type */
  'Upload.packType': '팩 유형',
  'Upload.packType.PLUS': '플러스팩',
  'Upload.packType.BASIC': '베이직팩',
  'Upload.movingStatus.ANIMATED': '움직이는 스티커',
  'Upload.movingStatus.STILL': '멈춰있는 스티커',

  /* Upload - Pack KeyText Form */
  'package.input.keyword.placeholder': '키워드를 입력하세요',

  /* Upload - creation-package : select package type */
  'Upload.PkgCreation.selectPackType.headline': '팩 작성하기',
  'Upload.PkgCreation.selectPackType.headline.undefined': '팩 작성하기',
  'Upload.PkgCreation.selectPackType.headline.PLUS': '플러스팩 작성하기',
  'Upload.PkgCreation.selectPackType.headline.BASIC': '베이직팩 작성하기',
  'Upload.PkgCreation.selectPackType.guide':
    '플러스팩, 베이직팩에 대해 궁금하신가요?',
  'Upload.PkgCreation.selectPackType.animatedStickerButton': '움직이는 스티커',
  'Upload.PkgCreation.selectPackType.stillStickerButton': '멈춰있는 스티커',
  'Upload.PkgCreation.selectPackType.caution.1':
    '한번 제안된 팩은 유형 변경이 불가합니다.',
  'Upload.PkgCreation.selectPackType.caution.2':
    '플러스팩과 베이직팩의 심사과정은 동일합니다.',
  'Upload.PkgCreation.selectPackType.caution.3':
    '플러스팩과 베이직팩의 심사 기간은 동일합니다.',
  'Upload.PkgCreation.selectPackType.PLUS.title': '플러스팩',
  'Upload.PkgCreation.selectPackType.PLUS.caption': '더 많은 판매채널 확보!',
  'Upload.PkgCreation.selectPackType.PLUS.description':
    '스티커 개수 <strong>24개 이상</strong>',
  'Upload.PkgCreation.selectPackType.BASIC.title': '베이직팩',
  'Upload.PkgCreation.selectPackType.BASIC.caption': '스티커 단 1개도 제안 OK!',
  'Upload.PkgCreation.selectPackType.BASIC.description':
    '스티커 개수 <strong>24개 미만</strong>',

  /* Upload - creation-package : create package */
  'Upload.PkgCreation.createPack.thumbnail.title': '팩 대표 이미지',
  'Upload.PkgCreation.createPack.packType': '팩 유형',
  'Upload.PkgCreation.createPack.packType.PLUS': '플러스팩',
  'Upload.PkgCreation.createPack.packType.BASIC': '베이직팩',
  'Upload.PkgCreation.createPack.packType.undefined': '유형 없음',
  'Upload.PkgCreation.createPack.packType.animated': '움직이는 스티커',
  'Upload.PkgCreation.createPack.packType.still': '멈춰있는 스티커',
  'Upload.PkgCreation.createPack.packName': '팩 이름',
  'Upload.PkgCreation.createPack.packDescription': '팩 설명',
  'Upload.PkgCreation.createPack.packDescription.caution':
    '팩 이름과 설명에 도덕・윤리적으로 부적합한 단어 또는  오탈자가 있는지 확인해주세요.',
  'Upload.PkgCreation.createPack.packInfoLanguage': '언어',
  'Upload.PkgCreation.createPack.packInfoLanguage.choice': '다른 언어 추가',
  'Upload.PkgCreation.createPack.packInfoLanguage.guide':
    '팩의 이름과 설명을 다양한 언어로 추가해보세요. 추가된 정보는 해당 팩이 노출 및 판매되는 국가의 사용자에게 제공됩니다.',
  'Upload.PkgCreation.createPack.packLanguage.selection': '팩 언어 선택',
  'Upload.PkgCreation.createPack.packLanguage.imageOnly': '텍스트 미포함',
  'Upload.PkgCreation.createPack.packLanguage.include': '언어 선택',
  'Upload.PkgCreation.createPack.packLanguage.caution':
    '팩 내 스티커에 텍스트가 포함되어 있는 경우, 해당 언어를 선택해주세요.',
  'Upload.PkgCreation.createPack.packLanguage.guide.title':
    '‘텍스트 미포함’ 사례',
  'Upload.PkgCreation.createPack.packLanguage.guide.description.1':
    '1. 이미지로만 구성된 경우',
  'Upload.PkgCreation.createPack.packLanguage.guide.description.2':
    '2. 이미지로 인식되는 특수기호를 사용한 경우',
  'Upload.PkgCreation.createPack.packKeyword': '팩 키워드',
  'Upload.PkgCreation.createPack.packKeyword.caution':
    '팩 검색을 위해 해당 팩의 주제 및 스타일을 키워드 태그로 나열해주세요.<br>팩과 상관없는 부적합한 키워드는 추후 검색에서 제외될 수 있으며, 최대 10개의 키워드를 등록 가능합니다.',
  'Upload.PkgCreation.createPack.savebutton': '저장',

  // /* Upload - creation-package : messages */
  // 'Upload.PkgCreation.createPack.message.fileSize': '이미지 사이즈가 너무 큽니다. 😨 ',
  // 'Upload.PkgCreation.createPack.message.thumbnail': '팩 대표 이미지를 등록해주세요. 🌈',
  'Upload.PkgCreation.createPack.message.thumbnailExt':
    '팩의 대표이미지는\nPNG 파일로 업로드 해주셔야 합니다.',
  // 'Upload.PkgCreation.createPack.message.input.packName': '팩 이름을 입력해주세요. ✏️',
  // 'Upload.PkgCreation.createPack.message.input.packName.english': '팩의 이름을 영어로 입력해주세요. 😢',
  // 'Upload.PkgCreation.createPack.message.input.packName.minLength': '팩의 이름은 3자 이상이어야 합니다. 😢',
  // 'Upload.PkgCreation.createPack.message.input.packDescription': '설명을 입력해주세요. 📒',
  // 'Upload.PkgCreation.createPack.message.input.packDescription.english': '설명은 영어로 작성해야합니다. 😢',
  // 'Upload.PkgC'

  'Upload.PkgCreation.createPack.popconfirm.message':
    '<div>팩 언어 변경 시 스티커 태그 및 언어 설정이 초기화됩니다. 😢<br>팩 언어를 변경하시겠습니까?</div>',
  'Upload.PkgCreation.createPack.langchange.error':
    '승인된 스티커가 있을시에는 언어 수정을 할 수 없습니다.',
  'Upload.PkgCreation.createPack.popconfirm.ok': '확인',
  'Upload.PkgCreation.createPack.popconfirm.cancel': '취소',

  /* Upload - progress-package : package list */
  'PkgInProgress.headline': '작성중',
  'PkgInProgress.not.pkgInProgress':
    '작성중인 팩이 없습니다.<br/>아래 버튼을 클릭해 새로운 팩를 업로드해 보세요!',
  'PkgInProgress.btn.createNewPkg': '+ 새로운 팩 작성하기',

  'PackageList.modal.btn': '확인',
  'PackageList.modal.title': '주의!',
  'PackageList.modal.description':
    '본인이 제작하거나 저작권을 보유한 콘텐츠를 업로드해주세요.📤',
  'PackageList.modal.distribute.info':
    '1. 팩 정보 입력 > 2. 스티커 업로드 > 3. 태그 선택 > 4. 제출 전 최종 확인 후 <br/> <strong>심사 제출하기</strong>를 누르면 바로 배포됩니다.',
  'PackageList.modal.distribute.caution':
    "팩의 '심사 제출하기'를 누른 후에는 수정할 수 없어요!🙅<br/> 꼼꼼히 확인 후 요청해주세요!🙏🙏🙏",

  'PackageItem.available': '배포 준비 중',

  /* Upload - progress-package : nav */
  'Upload.packagesInProgress.nav.packageInfo': '1. 팩 정보 입력',
  'Upload.packagesInProgress.nav.stickerUpload': '2. 스티커 업로드',
  'Upload.packagesInProgress.nav.selectTag': '3. 태그 선택',
  'Upload.packagesInProgress.nav.confirm': '4. 제출 전 최종 확인',

  /* Upload - progress-package : step */
  'Upload.packagesInProgress.step.info': '팩 정보 입력',
  'Upload.packagesInProgress.step.sticker-upload': '스티커 업로드',
  'Upload.packagesInProgress.step.select-tag': '태그 선택',
  'Upload.packagesInProgress.step.confirm': '제출 전 최종 확인',

  //2. PackageInfo.js
  'PackageInfo.tag': '팩을 생성해주세요 ',
  'PackageInfo.cover.text': '팩 대표 이미지',
  'PackageInfo.png.size': '이미지는 250x250(px)의 PNG 파일이어야 합니다.',
  'PackageInfo.package.name': '팩 이름 (영문)',
  'PackageInfo.package.name.pack': '팩 이름',
  'PackageInfo.package.name.local': '팩 이름 (한글)',
  'PackageInfo.package.name.local.explanation':
    '해당 팩의 한글 이름을 입력해주세요.',
  'PackageInfo.package.description': '설명',
  'PackageInfo.package.description.pack': '팩 설명',
  'PackageInfo.package.info.explanation':
    '팩 이름과 설명에 도덕・윤리적으로 부적합한 단어 또는 오탈자가 있는지 확인해주세요.',
  'PackageInfo.package.btn': '저장',

  'PackageInfo.package.language': '언어 선택',
  'PackageInfo.package.language.explain':
    '창작물의 텍스트 포함 여부를 선택하고, 텍스트가 포함된 경우 해당 언어를 선택할 수 있습니다.<br/>자세한 사항은 가이드의 스티커팜 사용방법을 참고해주세요',
  'PackageInfo.package.languageError.explain':
    '이 팩에는 언어 선택 설정이 필요합니다.',
  'PackageInfo.package.language.onlyImage': '텍스트 미포함',
  'PackageInfo.package.language.withText': '텍스트 포함',
  'PackageInfo.package.language.list.0': 'English',
  'PackageInfo.package.language.list.1': 'Korean',
  'PackageInfo.package.language.list.2': 'Chinese',
  'PackageInfo.package.language.list.3': 'Japanese',
  'PackageInfo.package.language.list.4': 'Vietnamese',
  'PackageInfo.package.language.list.5': 'Spanish',
  'PackageInfo.package.language.list.6': 'Arabic',
  'PackageInfo.package.language.list.7': 'German',
  'PackageInfo.package.language.list.8': 'French',
  'PackageInfo.package.language.list.9': 'Italian',
  'PackageInfo.package.language.list.10': 'Portuguese',
  'PackageInfo.package.language.list.11': 'Russian',

  'PackageInfo.noti.fileSize': '이미지 사이즈가 너무 큽니다. 😨 ',
  'PackageInfo.noti.thumbnail': '팩 대표 이미지를 등록해주세요. 🌈',
  'PackageInfo.noti.thumbnailExt':
    '팩의 대표이미지는\nPNG 파일로 업로드 해주셔야 합니다.',
  'PackageInfo.noti.input.name': '팩 이름을 입력해주세요. ✏️',
  'PackageInfo.noti.english.name': '팩의 이름을 영어로 입력해주세요. 😢',
  'PackageInfo.noti.input.description': '설명을 입력해주세요. 📒',
  'PackageInfo.noti.multiLangInfo.name.minLength':
    '팩의 이름은 1자 이상이어야 합니다. 😢',
  'PackageInfo.noti.multiLangInfo.name.maxLength':
    '팩의 이름은 최대 40자까지 입력 가능합니다. 😢',
  'PackageInfo.noti.multiLangInfo.description.minLength':
    '팩의 설명은 1자 이상이어야 합니다. 😢',
  'PackageInfo.noti.name.minLength': '팩의 이름은 3자 이상이어야 합니다. 😢',
  'PackageInfo.noti.name.maxLength':
    '팩의 이름은 최대 40자까지 입력 가능합니다. 😢',
  'PackageInfo.noti.english.description': '설명은 영어로 작성해야합니다. 😢',
  'PackageInfo.noti.languageSelection.input.language':
    '언어를 선택해주세요. 😢',
  'PackageInfo.noti.languageSelection.input.keyText.notValid':
    '팩 키워드는 영어와 숫자로 최대 10개까지 입력\n가능합니다.\n키워드 사이의 공백은 최대 2번까지 입력이 허용됩니다.',
  'PackageInfo.noti.languageSelection.input.keyText.noInput':
    '팩 키워드가 입력되지 않았습니다. 1개 이상의 팩 키워드를 입력해주세요. ✍️',
  'PackageInfo.noti.editPackage': '팩 대표 이미지 및 정보를 수정해주세요.',
  'PackageInfo.noti.editPackage.error':
    '팩 대표 이미지 및 정보에 수정되지 않은 항목이 있습니다.수정 후 저장 버튼을 눌러 저장을 완료해주세요.',
  'PackageInfo.noti.editPackage.error.title':
    '팩 이미지 및 정보를 수정해주세요.',
  'PackageInfo.noti.editPackage.error.description':
    '팩 이미지 및 정보에 수정되지 않은 항목이 있습니다.\n수정 후 저장 버튼을 눌러 저장을 완료해주세요.',
  'PackageInfo.noti.savePackage.error.title': '팩 정보를 저장해주세요!',
  'PackageInfo.noti.savePackage.error.description':
    '다음 단계로 이동을 위해서는 정보 저장이 필수입니다. 저장 버튼을 눌러 저장을 완료해주세요.',
  'PackageInfo.noti.savePackage.fail':
    '입력한 팩의 정보가 저장되지 않았습니다.\n다시 시도해주세요.',

  'PackageInfo.noti.savePackage.title': '팩 정보 저장 완료!',
  'PackageInfo.noti.savePackage.description':
    '입력한 팩 정보 저장이 완료되었습니다.\n2. 스티커 업로드 단계로 이동하세요.',
  'PackageInfo.error.nameOverlap': '이 팩 이름은 이미 사용중 입니다.',
  /* Upload - progress-package : 1. package info */
  //guide & guide modal
  'PackageInfo.guide.modal.btn': '팩 대표 이미지 제작 가이드',
  'PackageInfo.guide.modal.title': '팩 대표 이미지 제작 가이드',
  'PackageInfo.guide.modal.explain':
    '1. 이미지 파일은 500KB 이하의 250 x 250 (px) 로 제작해 주세요.<br/>2. 배경은 투명으로 해상도 72 dpi를 지켜주세요.<br/>3. 상하좌우 여백 20px을 권장합니다.<br>4. 팩 대표 이미지는 정지된 이미지(PNG)로 제작해 주세요.<br/><p style="margin: 10px 0px">자세한 제한사항들은 <u><a style="color:#a202ff" href="/guide/howToUse" target="_blank">제작 가이드 페이지</a></u>를 참고해 주세요.</p>',

  /* Upload - progress-package : 2. sticker upload */
  //guide & guide modal
  'StickerUpload.guide.title':
    '스티커 업로드를 클릭해 스티커 이미지를 업로드 하세요.',
  'StickerUpload.guide.title.PLUS':
    ' 최소 24개 이상의 파일을 업로드 할 수 있습니다.',
  'StickerUpload.guide.title.BASIC':
    ' 최대 23개 까지의 파일을 업로드 할 수 있습니다.',
  'StickerUpload.guide.modal.btn': '스티커 제작 가이드',
  'StickerUpload.guide.explain':
    '이미지 파일은 500KB 이하의 618 x 618 (px) 로 제작해 주세요. 배경은 투명으로 해상도 72 dpi를 지켜주세요.<br/>상하좌우 20px씩의 여백을 권장합니다. 자세한 제한사항들은 <a style="color:#a202ff" href="/guide/howToUse" target="_blank" rel="noopener noreferrer">제작 가이드 페이지</a>를 참고해 주세요.<br><span style="color:#FFBF00">노란색</span> 테두리는 수정이 필요한 상태의 스티커를 의미합니다. <span style="color:#a202ff">보라색</span> 테두리는 승인된 스티커를 의미합니다.',
  'StickerUpload.guide.modal.title': '스티커 제작 가이드',
  'StickerUpload.guide.modal.explain':
    '<ol style="padding-inline-start: 13px;"><li>이미지 파일은 500KB 이하의 618 x 618 (px) 로 제작해 주세요.</li><li>배경은 투명으로 해상도 72 dpi를 지켜주세요.</li><li> 상하좌우 여백 20px을 권장합니다.</li><li>GIF 저장 시 매트를 설정할 경우, 흰색 또는 없음 설정 후<br/>투명도 > “확산 투명 디더” 에 체크해주세요.</li></ol><p style="margin: 10px 0px">자세한 제한사항들은 <u><a style="color:#a202ff" href="/guide/animatedSticker" target="_blank">제작 가이드 페이지</a></u>를 참고해 주세요.</p>',

  'StickerUpload.stickerCount': '스티커 개수',
  'StickerUpload.stickerCount.desc.PLUS':
    '<span style="color:#ff6060">*</span><span style="color:rgba(0, 0, 0, 0.38); font-size:14px; line-height:22px; letter-spacing: -0.5px">최소 24개 이상의 파일을 업로드 할 수 있습니다.</span>',
  'StickerUpload.stickerCount.desc.BASIC':
    '<span style="color:#ff6060">*</span><span style="color:rgba(0, 0, 0, 0.38); font-size:14px; line-height:22px; letter-spacing: -0.5px">최대 23개 이하의 파일을 업로드 할 수 있습니다.</span>',

  'StickerUpload.tag': '스티커 파일을 업로드 해주세요 ',
  'StickerUpload.dragger.explain': '파일 드래그 또는 클릭!',
  'StickerUpload.dragger.format': '파일 형식 ：PNG, GIF',

  'StickerUpload.select.explain': '스티커 업로드',

  'StickerUpload.noti.stickerPixel':
    '이미지 사이즈가 맞지 않습니다. (618 x 618px로 맞춰주세요.) 😵',
  'StickerUpload.noti.stickerFormat':
    '파일 형식이 잘못되었습니다. (PNG, GIF만 가능합니다.) 😑',
  'StickerUpload.noti.stickerSize': '파일 크기는 500KB 이내입니다. 📁',
  'StickerUpload.noti.uploadSuccess':
    '스티커 업로드 완료!\n팩의 스티커가 업로드되었습니다.',
  'StickerUpload.noti.uploadFail': '',
  'StickerUpload.noti.deleteSuccess':
    '스티커 삭제 완료!\n팩의 스티커가 삭제되었습니다.',
  'StickerUpload.noti.deleteFail': '',

  'progressPkg.sticker.delete': '정말 삭제 하시겠습니까? 🤔',

  /* Upload - progress-package : 3. Select Tag */
  //guide & guide modal
  'SelectTag.guide.addTag': '태그 추가',
  'SelectTag.guide.title':
    '각 스티커를 클릭해 적절한 감정태그와 언어를 선택해주세요.',
  'SelectTag.guide.modal.btn': '태그 선택 가이드',
  'SelectTag.guide.explain':
    "감정태그와 언어 선택을 완료한 스티커에는 <span style='color:#5fffaf'>녹색</span> 테두리가, 완료하지 않은 스티커에는 <span style='color:#ff6060'>빨간색</span> 테두리가 나타납니다. 또한, 검수에 반려되어 수정이 필요한 경우에는 <span style='color:#FFBF00'>노란색</span> 테두리가 나타납니다. 승인이 완료된 경우에는  <span style='color:#a202ff'>보라색</span> 테두리가 나타납니다. <br/>작업을 완료하지 않으면 심사 제출이 불가능하니 꼭 완료해주세요!",
  'SelectTag.guide.modal.title': '스티커 태그 가이드',

  'SelectTag.guide.modal.explain.title': '🔍 태그 선택 기준',
  'SelectTag.guide.modal.explain.right':
    '<ul class="select-tag-guide-ul"><li style="margin:25px auto">스티커에서 유추할 수 있는 감정과 상황</li><li>스티커를 보면 가장 먼저 떠오르는 태그</li><li style="margin:25px auto">스티커에 직관적으로 매칭되는 태그</li></ul>',
  'SelectTag.guide.modal.explain.wrong':
    '<ul class="select-tag-guide-ul"><li style="margin:25px auto">스티커에서 유추할 수 없는 감정과 상황</li><li style="margin:25px auto">스티커의 감정과 상황에 관련이 없으며,<br/>배경으로서 스티커에 포함된 요소</li></ul>',

  'SelectTag.guide.modal.caution.title': '⚠️ 태그 선택 시 주의사항',
  'SelectTag.guide.modal.caution.description':
    '<ul style="list-style-type:decimal; padding-left:15px; margin-bottom:0px;"><li>스티커 하나 당 <strong>태그는 최소 1개에서 최대 3개까지 선택</strong>할 수 있습니다.</li><li>스티커의 <strong>감정/상황과 태그가 불일치</strong>할 경우 <strong>미승인 사유</strong>가 될 수 있습니다.</li><li>태그가 선택되지 않은 스티커는 제안할 수 없습니다.</li></ul>',

  'SelectTag.guide.link.message':
    '태그 선택 방법에 대한 더 자세한 안내는 <a href="/guide/selectTags" target="_blank">태그 선택 방법 페이지</a>를 참고해 주세요.',

  'SelectTag.guide.modal.exmaple.title': '🏷 태그 선택 기준 참고 예시',
  'SelectTag.guide.modal.exmaple.1':
    '<div>스티커에서 유추할 수 있는 감정과 상황 : <span>사랑 (Loving)</span></div><div style="margin-top:14px;">스티커의 감정과 상황에 관련된 배경요소 : <span>하트 (Heart)</span></div>',
  'SelectTag.guide.modal.exmaple.2':
    '<div>스티커에서 유추할 수 있는 감정과 상황 : <span>안녕 (Hi/Bye)</span></div><div style="margin-top:36px; color:#ff6060;">스티커에서 유추할 수 없는 감정과 상황 : <span>경례 (Salute)</span></div>',
  'SelectTag.guide.modal.exmaple.3':
    '<div>스티커에서 유추할 수 있는 감정과 상황 : <span>미소 (Grin, Smile)</span></div><div style="color:#ff6060; margin-top:14px">스티커에서 유추할 수 없는 감정과 상황 :  <span>큰 웃음 (LOL, 빵터짐)</span></div>',
  'SelectTag.guide.modal.exmaple.4':
    '<div>스티커에 직관적으로 매칭되는 태그 : <span>오토바이 (motorcycle)</span></div><div style="margin-top:14px; color:#ff6060;">스티커의 감정과 상황에 관련 없으며,<br/>배경으로서 스티커에 포함된 태그 : <span>나무 (Tree)</span></div>',
  'SelectTag.taginfo.tag': '태그',
  'SelectTag.taginfo.lang': '언어',
  'SelectTag.modal.title': '스티커 태그 및 언어 선택',
  'SelectTag.modal.sticker': '선택한 스티커',
  'SelectTag.modal.selectedTags': '선택한 태그 리스트',
  'SelectTag.modal.maxTags': '최대 3개 선택 가능',
  'SelectTag.modal.rightTagGuide.title': '⚠️ 정확한 태그 선택이 왜 중요한가요?',
  'SelectTag.modal.rightTagGuide.description':
    '<p>선택된 태그를 바탕으로 스티커가 스티커팜 사용자들에게 추천되기 때문에<br/>내 스티커의 효과적인 노출과 사용량 증가를 위해서는 정확한 태그가 필요합니다.<br/>스티커에 적절하게 매칭되는 태그를 키워드 검색과 태그 카테고리에서 골라보세요!</p><br/><p>💡스티커 태그 시 내 스티커에 맞는 태그를 찾지 못했다면,<br/>그만큼 스티커가 많은 사람들에게 공감을 받기 힘들다는 뜻이겠죠? 😂<br/>스티커 제작 전 태그 리스트를 참고하면 많은 사람들에게 쓰일 스티커를 만들 수 있어요.</p>',

  'SelectTag.modal.tagSelection.title': '1. 태그 선택',
  'SelectTag.modal.tagSelection.description':
    '스티커에 적절하게 매칭되는 태그를 키워드 검색과 태그 카테고리에서 골라보세요.<br>“태그 선택 방법"을 참고하여 태그를 선택해주세요.',
  'SelectTag.modal.keywordSearch.title': '키워드 검색으로 찾기',
  'SelectTag.modal.keywordSearch.description':
    '스티커와 어울리는 키워드를 검색해서 태그를 선택할 수 있어요!',
  'SelectTag.modal.categorySearch.title': '태그 카테고리에서 찾기',
  'SelectTag.modal.categorySearch.description':
    '이모지 카테고리를 참고하여 스티커와 어울리는<br>태그를 선택할 수 있어요!',

  'SelectTag.modal.languageSelection.title': '2. 언어 선택',
  'SelectTag.modal.languageSelection.description.PLUS':
    '스티커의 텍스트 포함 여부를 선택해주세요.',
  'SelectTag.modal.languageSelection.description.BASIC':
    '스티커에 텍스트가 포함되어 있는 경우, 해당 언어를 선택해주세요.',

  'SelectTag.modal.answerSticker.title': '태그 확인',
  'SelectTag.modal.answerSticker.description':
    "<span style='font-weight: 700'>업로드한 스티커와 예시 스티커</span>를 비교하여 태그가 올바르게 선택되었는지 확인해주세요! <br>태그 선택이 올바르지 않을 경우, 팩 판매가 이루어 지지 않을 수 있으니 신중하게 체크바랍니다.",
  'SelectTag.modal.answerSticker.selectedSticker': '선택한 스티커',
  'SelectTag.modal.answerSticker.selectedTag': '선택한 태그',
  'SelectTag.modal.answerSticker.selectedAnswerStickers':
    '선택한 태그의 예시 스티커',
  'SelectTag.modal.btn': '저장',
  'SeleteTag.modal.RefuseSticker': '태그가 잘못 선택된 예시 스티커',
  'SeleteTag.modal.RefuseSticker.explain':
    '    -  스티커에 맞지 않은 태그\n    -  스티커에 직접적으로 태그의 의미가 드러나지 않는 경우',
  'SelectTag.modal.answerSticker.select.description': '선택한 태그의 세부사항',

  /* Upload -  EmojiSearchInputWindow */
  'EmojiSearchInputWindow.inputSearchText.placeholder':
    '검색어를 입력해보세요.',

  /* Upload - progress-package : 4. summary */
  'PkgConfirm.noti.tagsNotExist':
    '스티커의 태깅이 끝나지 않았습니다.\n태깅을 완료해주세요.',
  'PkgConfirm.noti.editingIsNotComplete':
    '아직 수정/삭제되지 않은 미승인 스티커가 존재합니다.\n미승인 스티커의 수정/삭제를 완료해주세요.',
  'PkgConfirm.noti.PLUS.notEnoughStickerNumber':
    '플러스팩의 스티커 업로드는 최소 24개부터 가능합니다.\n24개 이상의 스티커를 업로드 해주세요.',
  'PkgConfirm.noti.BASIC.toManySticker':
    '베이직팩의 스티커 업로드는 최대 23개까지 가능합니다.\n23개 이하의 스티커를 업로드 해주세요. 24개 이상으로 구성되었다면 플러스팩으로 업로드 해주세요.',
  'PkgConfirm.btn': '심사 제출하기',
  'PkgConfirm.popconfirm.message':
    '<br>제출 전 최종 확인</br><div>제출 버튼을 누르기 전, 수정할 부분이 없는지 확인해주세요!<br/>스티커팩이 승인된 이후에는 팩 소개, 스티커, 태그 등을<br/>수정할 수 없습니다.</div>',
  'PkgConfirm.popconfirm.ok': '제 출',
  'PkgConfirm.popconfirm.cancel': '다시 한 번 꼼꼼히 볼래요',

  'PkgConfirm.modal.success.title': '업로드 완료!',
  'PkgConfirm.modal.success.description':
    '축하합니다!\n스티커팩이 제출되었습니다.\n스티커팩 심사결과는 심사가 끝나면 전송됩니다.',
  'SelectEmotion.modal.success.ok': '확인',

  'PkgConfirm.modal.fail.title': '업로드 실패!',
  'PkgConfirm.modal.fail.description':
    '이런!\n스티커팩이 제출되지 않았습니다.\n다시 시도해주세요.',
  'PkgConfirm.modal.fail.ok': '확인',

  /** Upload - packages-of-reviewed : ReviewedPkgList.js */
  'ReviewedPkgList.table.thumbnail': '대표 이미지',
  'ReviewedPkgList.table.packType': '팩 구분',
  'ReviewedPkgList.table.packTypeName': '팩 구분 & 팩 네임',
  'ReviewedPkgList.table.packType.BASIC': '베이직팩',
  'ReviewedPkgList.table.packType.PLUS': '플러스팩',
  'ReviewedPkgList.table.pkgName': '팩 이름',
  'ReviewedPkgList.table.reviewRequestedAt': '제출일',
  'ReviewedPkgList.table.approvedAt': '승인일',
  'ReviewedPkgList.table.status': '심사 현황',
  'ReviewedPkgList.btn.unapproved': '왜죠?🤔', //<- 미승인 사유 확인
  'ReviewedPkgList.headline': '심사 현황',
  'ReviewedPkgList.guide.title':
    '심사 제출한 팩의 심사 진행상황을 확인할 수 있습니다.',
  'ReviewedPkgList.guide.description':
    '승인 완료된 팩은 바로 배포되어 사용 가능합니다.<br/>미승인 팩은 썸네일을 클릭해 미승인 사유를 열람할 수 있으며, 수정해서 다시 제출할 수 있습니다.<br/>승인완료후 15일까지 심사현황에서 완료내역을 확인할 수 있습니다.',

  /** PackageInfo.js */
  'PackageInfo.type': '팩 종류',
  'PackageInfo.title': '팩 기본 정보',
  'PackageInfo.name.en': '팩 이름 (영문)',
  'PackageInfo.name.local': '팩 이름(한글)',
  'PackageInfo.description': '팩 설명 (영문)',
  'PackageInfo.status': '심사 상태',
  'PackageInfo.lang': '팩 언어',
  'PackageInfo.title.additional': '팩 추가 정보',
  'PackageInfo.keyText': '팩 키워드 (영문)',

  /** StickerInfo.js */
  'StickerInfo.title': '스티커 목록',
  'StickerInfo.text.tag': '태그',
  'StickerInfo.text.language': '언어',
  'StickerInfo.unapproved.alert.title.delete': '미승인 사유 - 삭제',
  'StickerInfo.unapproved.alert.title.edit': '미승인 사유 - 수정',

  /** PkgAndStickerInfo.js */
  'PkgAndStickerInfo.headline.creating': '작성중인 팩',
  'PkgAndStickerInfo.headline.underReview': '심사중인 팩',
  'PkgAndStickerInfo.headline.approved': '승인완료 팩',
  'PkgAndStickerInfo.headline.unapproved': '미승인 팩',
  'PkgAndStickerInfo.headline.editing': '수정중인 팩',
  'PkgAndStickerInfo.headline.discontinue': '배포중단 팩',

  'PkgAndStickerInfo.pkgDelete.message':
    '<div><span class="caution-mark">*</span> 팩 내의 모든 스티커가 미승인 C-G사유에 해당하는 경우, 해당 팩 삭제를 권장합니다.</div>',
  'PkgAndStickerInfo.pkgDelete.popconfirm.message':
    '<b>미승인 팩 삭제</b><div class="deleted-package-popconfirm">팩를 삭제합니다.<br/>새로운 팩를 만들어 제출해주세요.</div>',

  'PkgAndStickerInfo.btn.pkgDelete': '팩 삭제',
  'PkgAndStickerInfo.btn.resubmit': '수정해서 다시 제출',

  /* Guide.js */
  //0. guide navigation
  'Guide.nav.packType': '스티커팜 제안 방법',
  'Guide.nav.BASIC': '베이직팩',
  'Guide.nav.PLUS': '플러스팩',
  'Guide.nav.movingStatus': '스티커 타입',
  'Guide.nav.stillImageSticker': '멈춰있는 스티커',
  'Guide.nav.animatedSticker': '움직이는 스티커',
  'Guide.nav.howToUse': '스티커팜 사용법',
  'Guide.nav.inspiration': '자료실',
  'Guide.nav.rejectedReasons': '미승인 사유 목록',
  'Guide.nav.channel': '채널',
  'Guide.nav.selectTags': '태그 선택 방법',

  //0.5 Common part(still image sticker & animated sticker)
  'Guide.caution': 'Caution',
  'Guide.caution.description':
    '본인이 제작하거나 저작권을 보유한 콘텐츠로만 가능합니다.<br/>(본인이 저작권을 보유한 창작물을 재가공한 콘텐츠는 업로드 가능합니다.)',
  'Guide.format': '파일 형식',
  'Guide.size&margin': '크기',
  'Guide.size&margin.description':
    '-  스티커의 크기는 618 x 618 (px)이어야 합니다.\n- 이미지 파일 크기는 500KB 이하로 제작해주세요.',
  'Guide.size&margin.example': '크기 예시 : ',
  //formt table text(common part-still image sticker & animated sticker)
  'Guide.formatTable.format': '파일 형식',
  'Guide.formatTable.format.data': 'GIF', //only aminated sticker
  'Guide.formatTable.background': '배경',
  'Guide.formatTable.background.data': '투명',
  'Guide.formatTable.resolution': '해상도',
  'Guide.formatTable.colorMode': '컬러 모드',
  'Guide.formatTable.colorMode.data': 'RGB (권장)',
  //size&margins table text(common part-still image sticker & animated sticker)
  'Guide.sizeTable.dimensions': '사이즈',
  'Guide.sizeTable.margins': '여백',
  'Guide.sizeTable.margins.data': '사방 20px씩의 권장',
  'Guide.sizeTable.size': '파일 용량',
  'Guide.sizeTable.size.data': '500KB 이내',
  //frequent mistakes
  'Guide.frequentMistakes': '자주하는 실수!',
  'Guide.frequentMistakes.fitSize':
    '<p>스티커는 모든 모바일 환경에서<br/> 잘 보이도록 만들어주세요!</p>스티커의 크기가 규격보다 너무 작거나 복잡한 경우<br/> 모바일 환경에 따라 잘 보이지 않을 수 있어요.',
  'Guide.frequentMistakes.background':
    '<p>스티커의 배경은 투명으로 해주세요!</p>스티커에 꼭 배경이 필요하다면 배경처리가 가능하지만,<br/> 스티커의 컨셉과 연관이 없는 불필요한 배경은 삭제하여<br>주세요.',
  'Guide.frequentMistakes.fillInColor':
    '<p>스티커의 면은 꼭 채워주세요!</p>라인 드로잉으로 스티커를 제작한 경우<br/>스티커의 모든 면은 컬러로 채워주세요.',
  'Guide.frequentMistakes.lowImageQuality':
    '<p>스티커의 품질을 높여주세요!</p>스티커의 품질이 떨어지면,<br/> 모바일 환경에 따라 알아보기 힘들 수 있어요.<br/>해상도와 용량에 맞춰 고품질로 제작해주세요.',

  //1.Still Image Sticker
  'Guide.stillImageSticker.headline': '멈춰있는 스티커',
  'Guide.stillImageSticker.format.description':
    '팩 타입을 멈춰있는 스티커로 선택한 경우 PNG 외에 다른 파일 형식은 업로드되지 않습니다.',

  //2.Animated sticker
  'Guide.animatedSticker.headline': '움직이는 스티커',
  'Guide.animatedSticker.format.description':
    '팩 타입을 움직이는 스티커로 선택한 경우 GIF 외에 다른 파일 형식은 업로드되지 않습니다.',
  'Guide.animatedSticker.frame': '프레임',
  'Guide.animatedSticker.frame.description':
    '- 2프레임 이상 15프레임 이하로 제작해주세요.<br/>- GIF가 계속 재생 되도록 루프 반복을 설정해주세요.',
  'Guide.animatedSticker.frameTable.frame': '프레임',
  'Guide.animatedSticker.frameTable.frame.data': '15프레임 이하',
  'Guide.animatedSticker.frameTable.duration': '시간',
  'Guide.animatedSticker.frameTable.duration.data': '2초 이내',

  'Guide.animatedSticker.saveCaution': 'GIF 스티커 저장 시 주의사항',
  'Guide.animatedSticker.saveCaution.description':
    '- GIF 스티커 저장 시 매트 설정에 따라 테두리 유무가 결정됩니다.<br/>- GIF 내보내기 설정에서 매트를 설정할 때 방법 1, 2 중 선택해주세요.',
  'Guide.animatedSticker.saveCautionTable.dither': '방법 1',
  'Guide.animatedSticker.saveCautionTable.matteWhite': '방법 2',
  'Guide.animatedSticker.saveCautionTable.noMatte': 'X',
  'Guide.animatedSticker.saveCautionTable.dither.data':
    '매트 설정 > 없음\n투명도 > “확산 투명 디더” 체크',
  'Guide.animatedSticker.saveCautionTable.matteWhite.data':
    '매트 설정 > 흰색\n(흰색 필수)',
  'Guide.animatedSticker.saveCautionTable.noMatte.data':
    '매트 설정 > 없음\n투명도 > 투명 디더 없음 ',

  //3.How To Use
  'Guide.howToUse.headline': '스티커팜 사용법',
  'Guide.howToUse.headline.basicPack': '베이직팩',
  'Guide.howToUse.headline.plusPack': '플러스팩',
  'Guide.howToUse.definition.BASIC': '베이직팩 정의',
  'Guide.howToUse.definition.PLUS': '플러스팩 정의',
  'Guide.howToUse.definition.BASIC.desc.1':
    '1. 스티커 단 1개도 제안 OK! (1개 이상 24개 미만의 스티커를 포함한 팩)',
  'Guide.howToUse.definition.BASIC.desc.2':
    '2. 움직이는 스티커 (GIF)/멈춰있는 스티커(PNG) 모두 제안 가능합니다.',
  'Guide.howToUse.definition.BASIC.desc.3':
    '3. 심사 기간과 과정은 플러스팩과 동일합니다.',
  'Guide.howToUse.definition.BASIC.desc.4':
    '4. 한번 제안된 팩은 유형 변경이 불가합니다.',
  'Guide.howToUse.definition.PLUS.desc.1':
    '1. 24개 이상의 스티커를 보유한 팩을 제안해주셔야 합니다.',
  'Guide.howToUse.definition.PLUS.desc.2':
    '2. 더 많은 채널에서 판매가 가능해요.',
  'Guide.howToUse.definition.PLUS.desc.3':
    '3. 움직이는 스티커(GIF)/멈춰있는 스티커(PNG) 모두 제안 가능합니다.',
  'Guide.howToUse.definition.PLUS.desc.4':
    '4. 심사 기간과 과정은 베이직팩과 동일합니다.',
  'Guide.howToUse.definition.PLUS.desc.5':
    '5. 한번 제안된 팩은 유형 변경이 불가합니다.',
  'Guide.howToUse.subtitle.basicPack': '베이직팩 제안 방법',
  'Guide.howToUse.subTitle.basicPack.1': '1. 상단 메뉴의 Upload를 클릭합니다.',
  'Guide.howToUse.description.basicPack.1':
    '<span style="color: red">*</span>한번 제출된 팩은 수정이 불가하니 신중하게 제출해주세요.',
  'Guide.howToUse.subTitle.basicPack.2':
    '2. 베이직팩의 스티커 타입을 선택해주세요.',
  'Guide.howToUse.subTitle.basicPack.3': '3. 제안할 팩의 정보를 입력해주세요.',
  'Guide.howToUse.subTitle.basicPack.4':
    '4. 제안할 팩의 스티커를 업로드해주세요.',
  'Guide.howToUse.subTitle.basicPack.5':
    '5. 제안할 스티커의 태그와 언어를 선택해주세요.',
  'Guide.howToUse.subTitle.basicPack.6':
    '6. 모든 스티커의 태그 및 언어를 선택했다면, 심사 제출하기 버튼을 눌러 베이직 팩 제안을 완료해주세요.',
  'Guide.howToUse.description.basicPack.6':
    '<span style="color: red">*</span>한번 제출된 팩은 수정이 불가하니 신중하게 제출해주세요.',
  'Guide.howToUse.subtitle.plusPack': '플러스팩 제안 방법',
  'Guide.howToUse.subTitle.plusPack.1': '1. 상단 메뉴의 Upload를 클릭합니다.',
  'Guide.howToUse.description.plusPack.1':
    '<span style="color: red">*</span>한번 제출된 팩은 수정이 불가하니 신중하게 제출해주세요.',
  'Guide.howToUse.subTitle.plusPack.2':
    '2. 플러스팩의 스티커 타입을 선택해주세요.',
  'Guide.howToUse.subTitle.plusPack.3': '3. 제안할 팩의 정보를 입력해주세요.',
  'Guide.howToUse.description.plusPack.3':
    '<span style="color: red">*</span>팩 내의 텍스트는 한가지 언어만 제안할 수 있습니다.',
  'Guide.howToUse.subTitle.plusPack.4':
    '4. 제안할 팩의 스티커를 업로드해주세요.',
  'Guide.howToUse.subTitle.plusPack.5':
    '5. 제안할 스티커의 태그와 언어를 선택해주세요.',
  'Guide.howToUse.subTitle.plusPack.6':
    '6. 모든 스티커의 태그 및 언어를 선택했다면, 심사 제출하기 버튼을 눌러 플러스 팩 제안을 완료해주세요.',
  'Guide.howToUse.description.plusPack.6':
    '<span style="color: red">*</span>한번 제출된 팩은 수정이 불가하니 신중하게 제출해주세요.',

  'Guide.howToUse.createPkgRequirement.title': '⚠️ 팩 생성 시 최소 요구 사항',

  'Guide.howToUse.createPkgRequirement.title.image': '이미지',

  'Guide.howToUse.createPkgRequirement.imageTable.numberTitle': '개수',
  'Guide.howToUse.createPkgRequirement.imageTable.sizeTitle': '크기(px)',

  'Guide.howToUse.createPkgRequirement.imageTable.pkgImg':
    '<strong>팩 대표 이미지</strong>',
  'Guide.howToUse.createPkgRequirement.imageTable.pkgImg.number': '1개',
  'Guide.howToUse.createPkgRequirement.imageTable.pkgImg.size':
    '500KB이하, 해상도 72dpi의<br/>250*250(px)의 PNG 파일',

  'Guide.howToUse.createPkgRequirement.imageTable.stickerImg':
    '<strong>스티커 이미지</strong>',
  'Guide.howToUse.createPkgRequirement.imageTable.stickerImg.number.basic':
    '최소 1개 이상<br/>최대 이미지 개수 23개',
  'Guide.howToUse.createPkgRequirement.imageTable.stickerImg.number.plus':
    '최소 1개 이상<br/>최소 이미지 개수 24개',
  'Guide.howToUse.createPkgRequirement.imageTable.stickerImg.size':
    '500KB이하, 해상도 72dpi, 618*618(px)의<br/>이미지 (자세한 가이드는 왼쪽 메뉴에서<br/>스티커 타입을 선택)',

  'Guide.howToUse.createPkgRequirement.textTable': '텍스트',

  'Guide.howToUse.createPkgRequirement.textTable.languageTitle': '언어',
  'Guide.howToUse.createPkgRequirement.textTable.charactersTitle': '글자 수',

  'Guide.howToUse.createPkgRequirement.textTable.pkgName':
    '<strong>팩 이름</strong>',
  'Guide.howToUse.createPkgRequirement.textTable.pkgName.language': '영문 필수',
  'Guide.howToUse.createPkgRequirement.textTable.pkgName.characters':
    '최소 글자 수 3자 이상',

  'Guide.howToUse.createPkgRequirement.textTable.pkgDescription':
    '<strong>팩 설명</strong>',
  'Guide.howToUse.createPkgRequirement.textTable.pkgDescription.language':
    '영문 필수',
  'Guide.howToUse.createPkgRequirement.textTable.pkgDescription.characters':
    '최대 글자 수 제한 없음',

  //4.inspiration_line
  'Guide.inspiration.headline': '자료실',
  'Guide.inspiration.kakao.title': '🏅카카오 인기 크리에이터 이모티콘',
  'Guide.inspiration.kakao.description':
    '카카오톡 이모티콘 할인, 쿠폰 이벤트, 카카오프렌즈 이모티콘 선물하기, 카톡 이모티콘 구매는 카카오 이모티콘샵에서!',

  'Guide.inspiration.line.title': '🏅라인 인기 크리에이터 스티커',
  'Guide.inspiration.line.subtitle':
    'LINE 크리에이터스 스티커 – 최신 인기 스티커 | LINE STORE',
  'Guide.inspiration.line.description':
    'LINE 공식 온라인 스토어인 LINE STORE에서는 톡톡 튀는 크리에이터스 스티커뿐 아니라 인기 스타의 유행어가 가득가득한 개성만점 스티커도 찾아보실 수 있어요!',

  'Guide.inspiration.facebook.title': '🏅페이스북 스티커 스토어',
  'Guide.inspiration.facebook.subtitle': '스티커 스토어',
  'Guide.inspiration.facebook.description':
    '친구들에게 보낼 새 스티커를 찾아보세요.',

  'Guide.inspiration.telegram.title': '🏅텔레그램 스티커 카탈로그',
  'Guide.inspiration.telegram.subtitle': '텔레그램 스티커 - 주간 순위',
  'Guide.inspiration.telegram.description':
    '텔레그램 스티커의 주간 순위. 베스트 텔레그램 스티커.',

  'Guide.inspiration.viber.title': '🏅바이버 스티커 마켓',
  'Guide.inspiration.viber.subtitle': '스티커마켓 | 바이버',
  'Guide.inspiration.viber.description':
    '바이버의 스티커마켓. 무료, 신규, 콜렉션 스티커들을 다운로드 받으세요.',

  //5.Channel
  'Guide.channel.headline': '채널',
  'Guide.channel.tabs.service': '서비스',
  'Guide.channel.tabs.test': '테스트',

  //1)service tab
  'Guide.channel.service.mojitok.title':
    'App Store와 Play Store에서 mojitok을 만나보세요.',
  'Guide.channel.service.mojitok.explain':
    '1) 다운받은 mojitok 앱을 실행합니다.<br/>2) Discover 메뉴에서 텍스트를 입력하면 적합한 스티커가 추천됩니다.<br/>3) 추천된 스티커를 Whatsapp/Telegram/iMessage 등 다양한 메신저 앱에서 사용해보세요.',

  'Guide.channel.service.mojitok.galaxy.title':
    'Galaxy Keyboard에서 mojitok을 만나보세요.',
  'Guide.channel.service.mojitok.galaxy.explain':
    "1) Samsung Galaxy S10, Note 10/10+에서 갤럭시 키보드를 실행합니다.<br/>2) 스티커 아이콘을 클릭합니다.<br/>3) mojitok 아이콘을 클릭합니다.<br/>4) 'mojitok 다운로드' 버튼을 누르면 갤럭시 키보드에서 mojitok을 사용할 수 있습니다.",
  'Guide.channel.service.mojitok.galaxy.caution': '* 전기종 서비스 예정입니다.',

  'Guide.channel.service.fbExtension.title':
    'Facebook Messenger Extension에서 mojitok을 만나보세요.',
  'Guide.channel.service.fbExtension.explain':
    "1) 페이스북 메신저앱에서 mojitok을 검색합니다.<br/>2) '시작하기' 버튼을 누른 후 'Use Messenger Extension'을 누릅니다. <br/>3) 친구들과 대화 할 때 + 버튼을 누르면 mojitok extension을 사용할 수 있습니다.",

  'Guide.channel.service.globalFriend.title':
    'Global Friend에서 mojitok을 만나보세요.',
  'Guide.channel.service.globalFriend.explain':
    '1) 플레이 스토어 또는 앱스토어에서 Global Friend 앱을 다운받으세요.<br/>2) 친구들과 채팅할 때 사용하실 수 있습니다.<br/>3) 포스트를 남기거나 댓글을 남길 때도 사용하실 수 있습니다.',

  //2)test tab
  'Guide.channel.test.explain':
    '이 기능을 통해 스티커팜에 콘텐츠를 제안하기 전에<br/> mojitok의 기능을 미리 사용해 볼 수 있습니다.🕵🏻',

  // 6. How to Select Tags
  'Guide.selectTags.headline': '태그 선택 방법',
  'Guide.selectTags.description':
    '모히톡은 AI가 사용자의 메시지를 분석하여 적절한 스티커를 추천해주는 서비스입니다.<br/>모히톡 AI는 <strong>스티커를 업로드 할때 선택하는 태그를 기반으로 사용자의 메시지와 맞는 스티커를 매칭</strong>하기 때문에<br/>태그 선택은 정말 중요한 부분입니다!',
  'Guide.selectTags.tagSelection.title': '태그 선택 기준',
  'Guide.selectTags.caution.title': '태그 선택 시 주의사항',
  'Guide.selectTags.mistake.title.1':
    '스티커에서 직관적으로 유추할 수 있는 감정, 상황 등에 관련된 태그만 선택해 주세요!',
  'Guide.selectTags.mistake.title.2':
    '스티커를 보는 사람의 감정을 유추한 태그를 선택하면 안 돼요!',
  'Guide.selectTags.mistake.title.3':
    '스티커의 텍스트가 포함되어있을 경우 텍스트 내용에 해당하는 태그만 선택해 주세요!',
  'Guide.selectTags.mistake.title.4':
    '스티커와 관련 없는 배경 요소 태그는 선택하지 않아도 돼요!',
  'Guide.selectTags.mistake.description.1':
    '스티커에서 직관적으로 보여주고 있는 감정,<br/>상황 등에 관련된 태그만 선택하면 된답니다!<br/>스티커가 보여주고 있지 않은 태그까지<br/>유추하여 선택할 필요는 없어요.',
  'Guide.selectTags.mistake.description.2':
    '스티커가 나타내는 감정이 아닌, 스티커를 받은 사람의 감정을<br/>유추하여 태그를 선택하는 경우가 종종 있어요. <br/>숨은 감정 혹은 행동 이후 예상되는 감정이나 행동이 아닌 <br/>스티커가 현재 보여주고 있는 감정, 상황 태그만 선택해 주세요.',
  'Guide.selectTags.mistake.description.3':
    '스티커에 “Hi”, “Ok”, “Good” 등 스티커의 상황 및 감정 등을<br/>나타내는 텍스트가 포함되어 있을 경우<br/>텍스트의 내용에 해당하는 태그만 선택하면 돼요.',
  'Guide.selectTags.mistake.description.4':
    '스티커의 주인공과 관련된 주변 요소는 태그 선택이 가능해요.<br/>하지만 스티커 주인공의 행동, 감정 등과 관련 없는 배경까지<br/>세세한 태그는 선택하지 않아도 돼요.',

  /* UnapprovedCause.js */
  'UnapprovedCause.headline': '미승인 사유 목록',
  'UnapprovedCause.caution':
    '콘텐츠를 제출하기 전에 가이드 사유를 꼼꼼히 확인해주시기 바랍니다.<br>승인 이후에도 미승인 사유 가이드에 해당하는 경우 배포가 중단될 수 있습니다. 또한 미승인 사유 가이드에<br>해당하지는 않지만 부적절하다고 판단하는 경우 배포가 중단될 수 있습니다. 콘텐츠에 사진이 포함된 경우,<br>해당 사진에 대한 사용권 증명 서류를 요청할 수도 있습니다.<br>(update 2020.12.11.)',

  'UnapprovedCause.A.title': '콘텐츠 가이드 미준수',
  'UnapprovedCause.A.causes.1':
    '스티커의 여백(20px)을 남기지 않은 경우 승인이 되지 않습니다.',
  'UnapprovedCause.A.causes.2':
    '스티커가 규격에 비해 너무 작은 경우 승인이 되지 않습니다.',
  'UnapprovedCause.A.causes.3':
    '스티커의 면에 색을 채우지 않고 투명한 경우 승인이 되지 않습니다.',
  'UnapprovedCause.A.causes.4':
    '배경이 필요하지 않은 스티커인데 배경이 투명이 아닌 경우 승인이 되지 않습니다.',
  'UnapprovedCause.A.causes.5':
    '스티커의 품질이 너무 떨어질 경우 승인이 되지 않습니다.',
  'UnapprovedCause.A.causes.6':
    'GIF 루프를 반복 설정하지 않은 경우 승인이 되지 않습니다.',
  'UnapprovedCause.A.causes.7':
    'GIF의 움직임이 자연스럽지 않은 경우 승인이 되지 않습니다.',
  'UnapprovedCause.A.causes.8':
    '모바일 환경의 가시성이 떨어진다고 판단될 경우 승인이 되지 않습니다.',
  'UnapprovedCause.A.causes.9':
    '스티커 내에 오탈자가 있는 경우 승인이 되지 않습니다.',
  'UnapprovedCause.A.causes.10':
    '제안 시 선택한 스티커의 타입과 다른 형식의 스티커를 업로드 하신 경우 승인이 되지 않습니다.',

  'UnapprovedCause.B.title': '태그 및 언어 선택 가이드 미준수',
  'UnapprovedCause.B.subtitle.1': '태그 선택 가이드 미준수',
  'UnapprovedCause.B.subtitle.1.cause.1':
    '선택한 태그가 스티커가 나타내는 감정 및 상황과 일치하지 않은 경우 승인이 되지 않습니다.',
  'UnapprovedCause.B.subtitle.2': '언어 선택 가이드 미준수',
  'UnapprovedCause.B.subtitle.2.cause.1':
    '스티커의 언어 선택이 잘못된 경우 승인이 되지 않습니다.',

  'UnapprovedCause.C.title': '상품화 기준 미달',
  'UnapprovedCause.C.causes.1':
    '콘텐츠의 시각화 및 사용성 등의 부분에서 상품화가 부적절한 경우 승인이 되지 않습니다.',
  'UnapprovedCause.C.causes.2':
    '스티커팜 브랜드 이미지에 손상을 주거나 피해를 줄 수 있는 경우 승인이 되지 않습니다.',
  'UnapprovedCause.C.causes.3':
    '기존과 중복된 콘텐츠를 올린 경우 승인이 되지 않습니다.',
  'UnapprovedCause.C.causes.4':
    '이미지가 대화 내용에 도움이 되지 않는 경우 승인이 되지 않습니다.',

  'UnapprovedCause.D.title': '타 플랫폼과 동일 콘텐츠 등록',
  'UnapprovedCause.D.causes.1':
    '타 플랫폼과 동일한 콘텐츠를 등록한 경우 승인이 되지 않습니다.',

  'UnapprovedCause.E.title': '도덕 및 윤리 부적합',
  'UnapprovedCause.E.causes.1':
    '범죄나 선정적 표현, 욕설, 폭언 등의 콘텐츠를 등록한 경우 승인이 되지 않습니다.',
  'UnapprovedCause.E.causes.2':
    '사회적 물의를 일으킬 소지가 있는 콘텐츠를 등록한 경우 승인이 되지 않습니다.',
  'UnapprovedCause.E.causes.3':
    '흡연  및 흡연을 조장하는 콘텐츠를 등록한 경우 승인이 되지 않습니다.',
  'UnapprovedCause.E.causes.4':
    '반사회적인 내용이 포함 된 콘텐츠를 등록한 경우 승인이 되지 않습니다.',
  'UnapprovedCause.E.causes.5':
    '특정 지역이나, 국가, 종교, 문화, 집단 등에 대한 불쾌감을 유발할 소지가 있는 콘텐츠를 등록한<br> 경우 승인이 되지 않습니다.',

  'UnapprovedCause.F.title': '저작권, 초상권 침해 및 표절',
  'UnapprovedCause.F.causes.1':
    '다른 사람의 제품 또는 표절 된 저작권 또는 초상권을 침해 할 수 있는 콘텐츠를 등록한 경우<br> 승인이 되지 않습니다.',
  'UnapprovedCause.F.causes.2':
    '상표권을 침해하는 콘텐츠를 등록한 경우 승인이 되지 않습니다.',
  'UnapprovedCause.F.suffixRefer':
    "저작권 및 상표권에 대한 자세한 내용은 '한국저작권위원회', '특허청', '상표검색사이트'를 참고하시기<br> 바랍니다.",

  'UnapprovedCause.G.title': '비즈니스 및 광고 홍보와 같은 제안',
  'UnapprovedCause.G.prefixRefer':
    '비지니스 광고 및 홍보의 목적을 가진 경우에는, mojitok@platfarm.net으로 문의하시기 바랍니다.',
  'UnapprovedCause.G.causes.1':
    '제3자에게 이익을 제공하거나 서비스 및 광고/홍보를 위해 제작된 콘텐츠를 등록한 경우<br> 승인이 되지 않습니다.',
  'UnapprovedCause.G.causes.2':
    '기업에서 브랜드 및 서비스의 광고/홍보를 위해 제작된 콘텐츠를 등록한 경우<br> 승인이 되지 않습니다.',
  'UnapprovedCause.G.causes.3':
    '개인과 기업의 협업에 의한 콘텐츠를 등록한 경우 승인이 되지 않습니다.',
  'UnapprovedCause.G.causes.4':
    '광고성 문구를 포함하고 있는 콘텐츠를 등록한 경우 승인이 되지 않습니다.',
  'UnapprovedCause.G.causes.5':
    '정치적 요소를 포함한 콘텐츠를 등록한 경우 승인이 되지 않습니다.',

  'UnapprovedCause.H.title': '팩 가이드 미준수',

  'UnapprovedCause.H.subtitle.1': '팩 대표 이미지(썸네일) 가이드 미준수',
  'UnapprovedCause.H.subtitle.1.causes.1':
    '팩 대표 이미지(썸네일)에 팩 컨셉과 연관이 없는 불필요한 배경이 포함이 되어있는 경우<br> 승인이 되지 않습니다.',
  'UnapprovedCause.H.subtitle.1.causes.2':
    '팩 대표 이미지(썸네일)이 팩 내의 스티커와 연관이 되지 않는 경우 승인이 되지 않습니다.',
  'UnapprovedCause.H.subtitle.1.causes.3':
    '팩 대표 이미지(썸네일)에 저작권, 표절, 초상권 침해를 하는 경우 승인이 되지 않습니다.',
  'UnapprovedCause.H.subtitle.1.causes.4':
    '팩 대표 이미지(썸네일)이 모바일 환경의 가시성이 떨어진다고 판단될 경우 경우<br> 승인이 되지 않습니다.',
  'UnapprovedCause.H.subtitle.1.causes.5':
    '팩 대표 이미지(썸네일)이 도덕 및 윤리적으로 부적합한 내용을 포함한 경우<br> 승인이 되지 않습니다.',
  'UnapprovedCause.H.subtitle.1.causes.6':
    '팩 대표 이미지(썸네일)가  정지된 이미지(PNG)가 아닌 파일이 아닌 움직이는 이미지(GIF)로<br> 되어 있는 경우 승인이 되지 않습니다.',

  'UnapprovedCause.H.subtitle.2': '팩 정보 가이드 미준수',
  'UnapprovedCause.H.subtitle.2.causes.1':
    '팩 제목에 도덕 및 윤리적으로 부적합한 단어가 있는 경우 승인이 되지 않습니다.',
  'UnapprovedCause.H.subtitle.2.causes.2':
    '팩 설명에 도덕 및 윤리적으로 부적합한 단어가 있는 경우 승인이 되지 않습니다.',

  'UnapprovedCause.H.subtitle.3': '팩 규정 미준수',
  'UnapprovedCause.H.subtitle.3.causes.1':
    '팩 생성 시 최소 요구 사항을 준수하지 않거나 팩 정보가 부정확한 경우 승인이 되지 않습니다.',

  /* Mypage.js */
  //0. mypage navigation
  'Mypage.nav.setting': '내 정보',
  'Mypage.nav.myPackage': '팩 관리',
  'Mypage.nav.remittance-info': '송금 내역',
  'Mypage.nav.remittance-request': '송금 신청',

  //1. Setting
  'Mypage.setting.headline': '내 정보',
  'Mypage.setting.subTitle.email': '이메일',
  'Mypage.setting.subTitle.name': '이름/닉네임',
  'Mypage.setting.subTitle.country': '나라 선택',
  'Mypage.setting.subTitle.commenderCode': '추천인 코드',
  'Mypage.setting.subTitle.sns': '웹사이트 추가',
  'Mypage.setting.descriptoin.sns':
    '자신의 창작활동을 보여줄 수 있는 웹사이트를 추가해주세요.<br/><p>*</p>창작활동과 관계없는 웹사이트 추가 시 채널 노출이 불가할 수 있습니다.',
  'Mypage.setting.validUrl.error': '유효하지 않은 웹사이트입니다.',
  'Mypage.setting.btn': '저장',

  /** My Package.js  */
  'MyPackage.headline': '팩 관리',
  'Mypage.pkg.tab.all': '전체',
  'Mypage.pkg.tab.approved': '배포중',
  "Mypage.pkg.tab.editing": "수정중",
  'Mypage.pkg.tab.underReview': '심사중',
  'Mypage.pkg.tab.creating': '작성중',
  'Mypage.pkg.tab.unapproved': '미승인',

  //2. Credit
  'Mypage.credit.headline': '송금 내역',
  'Mypage.credit.subTitle': '송금 가능한 수익',

  'Mypage.credit.invoice.title': '송금 내역',
  'Mypage.credit.invoice.date': '신청 날짜',
  'Mypage.credit.invoice.amount': '신청 금액',
  'Mypage.credit.invoice.remittanceStatus': '송금 여부',
  'Mypage.credit.invoice.tableNotData': '신청한 정보가 없습니다.',
  'Mypage.credit.invoice.remittance.waitng': '송금 대기 중',
  'Mypage.credit.invoice.remittance.completion': '송금 완료',

  //3. Payouts
  'Payouts.headline': '송금 신청',

  'Payouts.select.account': '송금 받으실 계좌를 선택해 주세요.',
  'Payouts.select.account.explain':
    '($100 이상의 수익부터 송금 신청 할 수 있습니다.)',

  'Payouts.radio.other': '국제 (페이팔)',
  'Payouts.radio.korean': '한국',
  'Payouts.radio.vietnamese': '베트남',

  'Payouts.confirm.cancelText': '송금 가능한 수익 확인',
  'Payouts.confirm.message':
    '<b>송금 가능한 수익 부족</b><div>송금 가능한 수익이 $100 이상일 때부터 <br/>송금 신청을 할 수 있습니다. </div>',
  'Payouts.popover.btn': ' $100 이상부터 <br/>&emsp; 요청 할 수 있습니다.',
  'Payouts.korean.guide.phrase':
    '한국인이신 경우, 페이팔 대신 한국을 선택해주세요.',

  'Payouts.btn': '수익 송금 신청',
  'Payouts.check.apply': '송금 신청 전 꼭 확인해주세요.',

  'Payouts.collapse.header.korean': '한국 계좌를 보유하고 계신 경우',
  'Payouts.collapse.korean':
    '한국에서는 대금 수령인의 이름, 이메일, 은행과 계좌 번호를 입력해야 합니다.<br/>이메일은 반드시 사이트에 가입한 이메일을 입력하셔야 합니다.',
  'Payouts.collapse.header.vietnamese': '베트남 계좌를 보유하고 계신 경우',
  'Payouts.collapse.vietnamese':
    '베트남의 경우 대금 수령인의 이름, 납세코드, 계좌정보를 입력해야 합니다.<br/>개인소득세 납부 의무는 개인에게 있습니다.<br/><br/>이메일은 반드시 사이트에 가입한 이메일을 입력하셔야 합니다.',
  'Payouts.collapse.header.other': '국제 (페이팔을 사용하는 경우)',
  'Payouts.collapse.other':
    '페이팔의 프리미어 또는 비즈니스 계정을 사용하실 수 있습니다.<br/><br/>우선 페이팔 ID가 필요합니다.<br/>페이팔 사이트에서 계정을 등록해주세요.<br/><br/>그리고, 스티커팜 계정의 이메일과 페이팔 계정의 이메일이 동일해야 합니다.<br/>만약 다르실 경우, 페이팔 사이트에서 이메일을 추가하는 방법을 확인하세요.<br/><br/>페이팔 수수료가 적용됩니다.<br/>수수료에 대한 자세한 내용을 보시려면 페이팔 사이트에서 해당 국가의 수수료를 확인하세요.<br/><br/>※ 개인 계좌는 사용 불가합니다. <br/>페이팔 계정의 유형은 페이팔을 확인하세요.<br/><br/>※ 페이팔 계정이 반드시 미국 달러를 수신할 수 있도록 해주세요.<br/><br/>※한국에 거주하실 경우에는 페이팔로 요청할 수 없습니다.',

  //1.Payout - korea
  'PayoutsForm.korean.headline': '송금 신청 (한국)',
  'PayoutsForm.form.name': '이름:',
  'PayoutsForm.form.email': 'E-mail:',
  'PayoutsForm.form.email.explain': '*가입된 이메일을 입력해주세요',
  'PayoutsForm.form.account': '계좌:',
  'PayoutsForm.form.registNumber': '주민등록번호:',
  'PayoutsForm.form.registNumber.explain':
    '* 예금주의 주민등록번호를 입력하셔야 합니다.',
  'PayoutsForm.form.address': '주소 :',
  'PayoutsForm.form.zoneCode.btn': '우편번호 검색',
  'PayoutsForm.form.payment.amount.request': '송금 요청 금액 ($) : ',
  'PayoutsForm.request.btn': '송금 신청 완료하기',

  //messages
  'PayoutsForm.form.name.error.required': '이름을 입력해주세요',
  'PayoutsForm.form.email.error.required': 'Email을 입력해주세요',
  'PayoutsForm.form.email.error.type': '올바르지 않은 이메일 주소 입니다',
  'PayoutsForm.form.accountBank': '은행을 선택해주세요',
  'PayoutsForm.form.bankDefault': '은행',
  'PayoutsForm.form.accountNumber': '계좌 번호',
  'PayoutsForm.form.accountNumber.error.required': '계좌 번호를 입력해주세요',
  'PayoutsForm.form.accountNumber.error.type':
    '올바르지 않은 계좌 번호 입니다.',
  'PayoutsForm.form.accountName': '예금주',
  'PayoutsForm.form.accountName.error.required': '예금주를 입력해주세요',
  'PayoutsForm.form.registNumFront': '생년월일',
  'PayoutsForm.form.registNumFront.error.required':
    '주민등록번호를 앞자리를 입력해주세요',
  'PayoutsForm.form.registNumFront.error.type':
    '올바르지 않은 주민등록번호입니다',
  'PayoutsForm.form.registNumBack.error.required':
    '주민등록번호 뒷자리를 입력해주세요',
  'PayoutsForm.form.registNumBack.error.type':
    '올바르지 않은 주민등록번호입니다',
  'PayoutsForm.form.zoneCode.error.required': '주소를 검색해주세요',
  'PayoutsForm.form.detailAddress': '나머지 주소',
  'PayoutsForm.form.payment.request.error.required':
    '요청할 결제금을 입력해주세요',
  'PayoutsForm.form.payment.request.error.type':
    '$100이상의 금액부터 $단위로 신청 가능합니다.',
  'PayoutsForm.form.payment.request.notMatchEmail':
    '가입하신 이메일과 일치하지 않습니다.',
  'PayoutsForm.form.payment.request.failed':
    '신청 가능한 크레딧이 아닙니다. 확인해주세요.',
  'PayoutsForm.form.payment.request.mail.success': '요청 성공',
  'PayoutsForm.form.payment.request.mail.error': '이런! 다시 시도해주세요.',

  //bank
  'PayoutsForm.korean.form.account.bank.NH': '농협',
  'PayoutsForm.korean.form.account.bank.KB': '국민',
  'PayoutsForm.korean.form.account.bank.Shinhan': '신한',
  'PayoutsForm.korean.form.account.bank.Woori': '우리',
  'PayoutsForm.korean.form.account.bank.Hana': '하나',
  'PayoutsForm.korean.form.account.bank.IBK': 'IBK 기업',
  'PayoutsForm.korean.form.account.bank.SC': 'SC제일은행',
  'PayoutsForm.korean.form.account.bank.Citi': '씨티',
  'PayoutsForm.korean.form.account.bank.KDB': 'KDB산업',
  'PayoutsForm.korean.form.account.bank.ACU': '새마을',
  'PayoutsForm.korean.form.account.bank.Daegu': '대구',
  'PayoutsForm.korean.form.account.bank.Kwangju': '광주',
  'PayoutsForm.korean.form.account.bank.KoreaPost': '우체국',
  'PayoutsForm.korean.form.account.bank.Shinhyup': '신협',
  'PayoutsForm.korean.form.account.bank.Jeonbuk': '전북',
  'PayoutsForm.korean.form.account.bank.Kyongnam': '경남',
  'PayoutsForm.korean.form.account.bank.Busan': '부산',
  'PayoutsForm.korean.form.account.bank.Suhyup': '수협',
  'PayoutsForm.korean.form.account.bank.Jeju': '제주',
  'PayoutsForm.korean.form.account.bank.Kakao': '카카오 ',
  'PayoutsForm.korean.form.account.bank.HSBC': 'HSBC',
  'PayoutsForm.korean.form.account.bank.ICBC': '중궁공상',
  'PayoutsForm.korean.form.account.bank.JP': 'JP 모간',
  'PayoutsForm.korean.form.account.bank.Deutsche': '도이치',
  'PayoutsForm.korean.form.account.bank.BNP': 'BNP파리바',
  'PayoutsForm.korean.form.account.bank.BOA': 'BOA',
  'PayoutsForm.form.payment.credit': '송금 가능한 수익 : ',

  //2.Payouts-vietnam
  'PayoutsForm.vietnam.headline': '송금 신청 (베트남)',
  'PayoutsForm.vietnam.form.name.explain':
    '* 지급 받는 사람의 이름을 입력해주세요',
  'PayoutsForm.vietnam.form.taxPaymentCode.error.required':
    '납세코드를 입력해주세요',
  'PayoutsForm.vietnam.form.taxPaymentCode': '납세 코드 : ',

  //3.Payouts-PayPal
  'PayoutsForm.paypal.headline': '송금 신청 (페이팔)',

  /* FAQ.js */
  'FAQ.headline': 'FAQ',
  // FAQ - menu
  'FAQ.menu.suggestion': '제안',
  'FAQ.menu.registration': '등록',
  'FAQ.menu.distribution': '배포',
  'FAQ.menu.credit': '수익',

  // FAQ - subTitle
  'FAQ.subtitle.suggestion': '제안',
  'FAQ.subtitle.registration': '등록',
  'FAQ.subtitle.distribution': '배포',
  'FAQ.subtitle.revenue': '수익',

  //FAQ - collapse title(Panel header)
  'FAQ.collapse.suggestion.title.1':
    '스티커 제안을 위한 상세 조건을 알고 싶습니다.',
  'FAQ.collapse.suggestion.title.2': '스티커 제안 시 주의사항이 있을까요?',
  'FAQ.collapse.suggestion.title.3':
    '스티커 제안 시 정해진 크기와 개수가 있나요?',
  'FAQ.collapse.suggestion.title.4':
    '플러스팩과 베이직팩의 차이점이 무엇인가요?',
  'FAQ.collapse.suggestion.title.5':
    '플러스팩과 베이직팩의 스티커 제안 후 심사 기간은 얼마나 소요되나요?',
  'FAQ.collapse.registration.title.1':
    '기존 스티커들을 플러스팩으로 재 업로드 가능한가요?',
  'FAQ.collapse.registration.title.2':
    '베이직팩 승인 이후에 스티커를 더 추가해서 플러스팩으로 전환할 수 있나요?',
  'FAQ.collapse.registration.title.3':
    '베이직팩처럼 플러스팩에도 다양한 언어의 스티커를 업로드 할 수 있나요?',
  'FAQ.collapse.registration.title.4': '팩 정보는 영어로만 입력이 가능한가요?',
  'FAQ.collapse.registration.title.5': '팩의 삭제는 가능한가요?',
  'FAQ.collapse.registration.title.6': '감정 태그 선택은 필수인가요?',
  'FAQ.collapse.distribution.title.1': '승인 완료된 팩은 바로 배포되나요?',
  'FAQ.collapse.distribution.title.2': '스티커 미승인 사유에 대해 알고 싶어요.',
  'FAQ.collapse.distribution.title.3':
    ' 배포가 시작된 스티커는 어디에서 사용 되나요?',
  'FAQ.collapse.revenue.title.1': '팩이 배포되면, 수익이 발생하나요?',
  'FAQ.collapse.revenue.title.2':
    '수익은 언제 어떻게 송금할 수 있나요? (한국, 베트남 본인 계좌가 있는 경우)',
  'FAQ.collapse.revenue.title.3': '수익 송금처 정보는 어떻게 등록하면 되나요?',
  'FAQ.collapse.revenue.title.4': '수익의 통화는 무엇인가요?',
  'FAQ.collapse.revenue.title.5': '수익 송금처는 지정할 수 있나요?',
  'FAQ.collapse.revenue.title.6': '송금 신청이 불가능한 국가가 있나요?',

  //FAQ - Panel
  //suggestion
  'FAQ.collapse.suggestion.explain.1':
    '스티커팜은 누구든지 스티커를 제안할 수 있어요.<br/>지금 바로 도전해보세요!',
  'FAQ.collapse.suggestion.explain.2':
    '스티커 제작 시 가이드를 꼭 확인하여 작업해주세요.<br/>스티커 제안은 본인이 직접 제작하거나 저작권을 보유한 콘텐츠로만 가능합니다.<br/><br/>※ 제안을 위해서는 스티커팜에 메일 계정 등록 후 제안해주세요.',
  'FAQ.collapse.suggestion.explain.3':
    '스티커팜에서는 스티커 단 한개로도 제안이 가능합니다.<br/>단, 스티커의 크기는 제작 전 가이드라인을 반드시 확인해주세요.',
  'FAQ.collapse.suggestion.explain.4':
    '베이직팩의 경우 스티커 단 1개만 업로드해도 제안이 가능합니다. 플러스팩은 24개 이상의 스티커를 업로드해야만 제안이 가능하지만, 베이직팩보다 더 많은 판매 채널 및 수익의 기회를 확보할 수 있습니다.',
  'FAQ.collapse.suggestion.explain.5':
    '심사 기간은 4일에서 최대 2주 내외까지 소요되며, 플러스팩과 베이직팩의 심사 과정 및 심사 기간은 동일합니다.',

  //registration
  'FAQ.collapse.registration.explain.1':
    '기존에 등록했던 팩의 스티커와 플러스팩의 스티커가 같을 경우 중복 콘텐츠로 미승인 사유에 해당합니다. 또한, 플러스팩 업로드라는 사유로는 기존 팩 배포 중지 요청이 불가합니다.',
  'FAQ.collapse.registration.explain.2':
    '스티커 업로드 시 설정한 팩의 유형은 변경이 불가능합니다.',
  'FAQ.collapse.registration.explain.3':
    '플러스팩은 이미지 외에 추가로 한 가지 언어로만 구성할 수 있습니다.',
  'FAQ.collapse.registration.explain.4':
    '기본적인 팩 정보 입력은 영어 사용을 권장합니다. 영어 외에 다른 언어로의 팩 정보 입력이 필요하다면, ‘다른 언어 추가’ 버튼을 눌러 추가할 수 있습니다.',
  'FAQ.collapse.registration.explain.5':
    '배포가 완료된 팩은 등록된 스티커 각각의 사용량에 따라 즉시 수익에 반영됩니다. 따라서 배포 완료된 팩과 팩 내의 스티커는 삭제가 불가능합니다.',
  'FAQ.collapse.registration.explain.6':
    '스티커 등록 시 감정 태그 선택은 필수입니다.<br/>여러분이 선택한 감정 태그를 바탕으로 스티커가 추천되기 때문에<br/>감정, 상황, 행동, 물체 등 해당 스티커에 적합한 태그를 선택해주세요.<br/><br/>적합하지 않은 태그 추가는 미승인 사유에 해당되므로<br/> 태그 가이드를 참고하여 한 개 이상의 태그를 적절하게 선택해주세요!',

  //distribution
  'FAQ.collapse.distribution.explain.1':
    '스티커 제안 후 심사에 통과한 팩의 스티커들은 바로 배포됩니다.',

  'FAQ.collapse.distribution.explain.2':
    '스티커 미승인 사유는 <a href="/guide/rejectedReasons" target="_blank">“미승인 사유 가이드”</a>를 참고해주세요.',

  'FAQ.collapse.distribution.explain.2.caution':
    '미승인 사유 가이드에 해당하지 않더라도 스티커팜이 부적절하다고 판단한 경우, 배포 이후에도 판매가 중단될 수 있습니다.',

  'FAQ.collapse.distribution.explain.3':
    "당사와 콘텐츠 계약을 맺은 글로벌 메신저 서비스, 챗봇 등의 앱 또는 웹 서비스에서 사용됩니다.<br/>사용 가능한 서비스 리스트는 Guide 메뉴의 '채널' 탭에서 확인할 수 있어요.",

  //credit
  'FAQ.collapse.revenue.explain.1':
    '수익은 배포된 팩의 판매와 스티커 사용량을 기준으로 매달 책정되며 정해진 날짜에 일괄 지급됩니다.',
  'FAQ.collapse.revenue.explain.2':
    '지급된 수익에 대한 송금 신청은 최소 $100부터 신청 가능합니다.<br/>송금 신청 시 입력된 크리에이터의 개인정보는 송금을 위한 용도로만 사용되며 송금 이후 폐기됩니다.<br/>수익금은 송금 신청 이후 최대 45일 이내에 입력하신 송금처로 입금됩니다. (3.3% 공제)<br/><br/>매월 14일까지 송금 신청 시, 신청 월 말일에 입금되며<br/>매월 15일 이후 송금 신청 시, 다음 달 말일에 입금됩니다.<br/><br/>ex) 3월 14일 송금 신청 -> 3월 31일 입금<br/><p style="margin-left: 23px;">3월 16일 송금 신청 -> 4월 30일 입금</p>',
  'FAQ.collapse.revenue.explain.3':
    '마이페이지에서 등록할 수 있습니다.<br/>단, 송금 신청 시 입력하는 메일 주소는 스티커팜 계정의 메일 주소와 동일해야 합니다.',
  'FAQ.collapse.revenue.explain.4': '미국 달러($)입니다.',

  'FAQ.collapse.revenue.explain.5.subtitle.1': '한국, 베트남에 거주하시는 경우',
  'FAQ.collapse.revenue.explain.5.subExplain.1':
    '- 한국, 베트남 내 금융기관(은행 및 신용금고 등)을 이용할 수 있습니다.<br/><br/>',
  'FAQ.collapse.revenue.explain.5.subtitle.2':
    '한국, 베트남 이외의 국가에서 거주하시는 경우',
  'FAQ.collapse.revenue.explain.5.subExplain.2':
    '- Paypal의 프리미어 계정 또는 비즈니스 계정을 이용할 수 있습니다.<br/><br/>※ 퍼스널 계정은 이용할 수 없습니다. PayPal 계정의 종류에 대한 내용은 PayPal에서 확인해주세요.<br/>※ 고객님의 PayPal 계정이 미국 달러를 수령할 수 있는지 확인해주세요.<br/>※ 한국에 거주하시는 경우는 PayPal 계정으로 등록할 수 없습니다.',

  'FAQ.collapse.revenue.explain.6':
    'PayPal 송금이 불가능한 국가 및 지역에서는 수익 송금이 불가능합니다.<br/>원활한 수익 송금을 위해 PayPal 송금 가능 지역을 확인해주세요.',

  /* ComingSoon.js */
  'ComingSoon.headline': '공사 중입니다',
  'ComingSoon.description':
    '현재 페이지는 서비스 준비중입니다.<br/>조금만 기다려 주시면 좋은 서비스로 찾아뵙겠습니다.',

  /* Report.js - report 페이지 완성 전까지 */
  'Report.title': '<span style="color:#a202ff;">스티커야…</span> 잘 있니?',
  'Report.description':
    '창작의 고통으로 낳은 내 소중한 스티커!<br/>어디서 어떻게 잘 크고 있는 궁금하셨죠?<br/><br/>아무도 안 알려주었던 <strong>내 스티커의 성장</strong>을<br/>스티커팜이 알려드립니다!',

  'Report.ready.title':
    '그래서 <span style="color:#a202ff;">스티커팜</span>은<br/>이런걸 준비하고 있어요!',

  'Report.dashbard.title': '대시보드',
  'Report.dashbard.description':
    '나에 대한 정보만 모았다!<br/>누구도 아닌, 오직 나만을 위한 꿀팁 대방출',

  'Report.stats.title': '통계 리포트',
  'Report.stats.description':
    '내 활동, 인기 스티커, 수익까지!<br/>스티커팜이 드리는 자세한 통계 리포트를 받아보세요.',

  'Report.cheering.message':
    '열심히 준비중인 스티커팜을 응원하신다면 <br/><strong>👇하트를 꾹 꾹👇</strong>',
  'Report.cheering.message.push': '<strong>👆눌러주세요!👆</strong>',

  'Report.nav.dashboard': '대시보드',
  'Report.nav.ranking': '스티커 랭킹',
  'Report.nav.revenue': '수익',

  /**Report / Revenue.js */
  'Report.revenue.headline': '수익',
  'Report.revenue.revenueReport': '수익 리포트',
  'Report.revenue.monthlyRevenue': '{month}월 수익',
  'Report.revenue.accumulationRevenue': '누적 수익',
  'Report.revenue.monthlyRevenueTrend': '월 별 수익 추이',
  'Report.revenue.last12months': '최근 12개월',

  /**Report / Dashboard.js */
  'Report.dashboard.headline': '대시보드',
  'Report.dashboard.title.hello': '안녕하세요!',
  'Report.dashboard.title.creator': '<p>크리에이터 {creator}님</p>',
  'Report.dashboard.guide.text': '월별 리포트 가이드',
  'Report.dashboard.monthlyReport': '월별 리포트',
  'Report.dashboard.monthlyReport.guide':
    '그래프에 마우스를 올려 매월 노출/사용/활동 지수를 확인할 수 있습니다.',
  'Report.dashboard.pointViewer.title': '{month} {point}',
  'Report.dashboard.pointViewer.explain.viewPoint':
    "크리에이터의 스티커들이 mojitok 서비스에<br/><span class='tooltip-title-highlight'>얼마나 등장했는지를</span> 나타내는 지표",
  'Report.dashboard.pointViewer.explain.sharePoint':
    "mojitok 사용자들이 크리에이터의 스티커들을<br/><span class='tooltip-title-highlight'>얼마나 구매하고 전송했는지</span>를 나타내는 지표",
  'Report.dashboard.pointViewer.explain.activityPoint':
    "크리에이터가 스티커팜에서<br/><span class='tooltip-title-highlight'>얼마나 열심히 활동했는지</span>를 나타내는 지표",

  'Report.dashboard.noData.explain.title':
    '{creator}님의 스티커팜 가입을 환영합니다!',
  'Report.dashboard.noData.explain.description':
    '아직 {creator} 님의 스티커팜 활동이 충분히 수집되지 않아, 지수를 계산하지 못했어요.😢<br/>한 달 간 스티커팜에서 열심히 활동한 노출/사용/활동지수는 스티커팜이 꼼꼼히 계산해 다음 달에 보여드릴게요.',
  'Report.dashboard.noData.explain.guide':
    '월별 노출/사용/활동지수는 익월 2번째 주에 공개됩니다.',

  /*CheckPolicy.js*/
  'CheckPolicy.checkbox.title': '약관을 모두 읽었습니다.',
  'CheckPolicy.noti.check': '약관을 모두 읽고 동의해주세요.',
  'CheckPolicy.agreeBtn': '동의',

  /*페이지 상관없이 사용되는 에러 메세지들 */
  'ErrorMessage.noLanguageSelected':
    '언어를 선택하지 않았습니다. ‘그 외’ 언어 선택을 해주세요.',
  'ErrorMessage.noStickersInPkg':
    '스티커가 추가되지 않았습니다.🤯&nbsp;&nbsp;&nbsp;스티커를 1개 이상\n 추가해 주세요.',
  'ErrorMessage.noLangPlusPack': '플러스팩의 언어가 설정되어 있지 않습니다.',
}
